import React, { Component } from 'react';
import styled from 'styled-components';
import Modal from './home-components/Home-Modal';
import jobService from '../database/jobService';
import keywordService from '../database/keywordService';
import zoomService from '../database/zoomService';
import emailSubscriptionService from '../database/emailSubscriptionService';
import jobPostParser from '../AI/jobPostParser'; 
import { db } from '../database/firebase'; // Adjust path as needed
import CookieBanner from '../home/home-components/CookieBanner';
import { collection, query, orderBy, onSnapshot, doc, getDoc, addDoc, serverTimestamp, } from 'firebase/firestore';


const Styles = styled.div `

    // - - HOME CONTAINER - - //

.home-container {
    width:100%;
    height:100vh;
    // border: 1px solid black;
    position: fixed;
    display: flex;
    flex-direction: column;
}

    // - - TERMS OF SERVICE / PRIVACY POLICY LINKS - - //

.big-screen-links {
    position: absolute;
    top: 0;
    left: 0;
    width: 30%;
    height: 3.5%;
    display: flex;
    flex-direction: row;
    // border: 1px solid black;
    align-items: center;
    padding-left: 0.45%;
    z-index: 999;
}

.big-screen-links p {
    margin-right: 5%;
    font-family: figtree;
    font-size: 12px;
    color: blue;
}

.big-screen-links p:hover {
    cursor: pointer;
    text-decoration: underline;
}

    // - - NOTIFICATION MODAL - - //

.notificationModal {
    position: absolute;
    top: 0.8%;
    left: 0.5%;
    width: 20%;
    height: 75px;
    background-color: white;
    border: 1.25px solid #11b677;
    z-index: 1000;
    transform: translateX(-150%);
    transition: transform 0.8s ease;
}

.notificationModal.display {
    transform: translateX(0%);
}

.notificationModal img {
    position: absolute;
    top: 5%;
    right: 2.5%;
    width: 17.5px;
    height: 17.5px;
}

.notificationModal img:hover {
    cursor: pointer;
}

.notificationModal p {
    text-align: left;
    margin-top: 6.5%;
    padding-left: 3.5%;
    padding-right: 3.5%;
    font-size: 13px;
    padding-bottom: 0.5%;
    font-family: figtree;
    // color: #11b677;
    font-weight: bold;
}

    // - - HOME CONTAINER HEADER - - //

.home-container-header {
    width:100%;
    // border: 1px solid black; 
    height: 90px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.home-container-header span {
    font-weight: bold;
}

.home-container-header h4 {
    position: absolute;
    bottom: 15%;
    left: 0.5%;
    font-size: 14px;
    font-family: figtree;
    font-weight: normal;
    margin-top: 0px;
    margin-bottom: 0px;
}

.home-container-header-subscription-box {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 30%;
    // border: 1px solid black;
    z-index: 5;
}

.home-container-header-subscription-box h5 {
    position: absolute;
    top: 0;
    left: 0;
    text-align: left;
    font-size: 14px;
    font-family: figtree;
    margin-top: 12.5px;
    margin-left: 3.25px;
    font-weight: normal;
}

.home-container-header-subscription-box:after {
    content: '';
    display: table;
    clear: both;
}

.home-container-header-subscription-box-left {
    float: left;
    height: 100%;
    width: 65%;
    // border: 1px solid black;
    position: relative;
}


.home-container-header-subscription-box-left p {
    text-align: left;
    font-size: 14px;
    font-family: figtree;
    margin-top: 12.5px;
    margin-left: 3.25px;
}

.home-container-header-subscription-box-left-email-box {
    position: absolute;
    height: 60%;
    // border: 1px solid black;
    width: 100%;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: top;
}

.home-container-header-subscription-box-left-email-box.isEmpty input {
    border: 1px solid red;
}

.home-container-header-subscription-box-left-email-box input {
    height: 70%;
    width: 92.5%;
    padding-left: 2.5%;
    padding-right: 2.5%;
    font-size: 14px;
    outline: none;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.home-container-header-subscription-box-right {
    float: left;
    height: 100%;
    width: 34%;
    // border: 1px solid black;
    position: relative;
}

.home-container-header-subscription-box-right-subscribe-btn-box {
    position: absolute;
    height: 60%;
    // border: 1px solid black;
    width: 100%;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: top;
}

.home-container-header-subscription-box-right-subscribe-btn {
    position: absolute;
    top: -0.75px;
    width: 90%;
    height: 70%;
    border: 1.95px solid #2CE8A3;
    background-color: #2CE8A3;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding-bottom: 1%;
}

.home-container-header-subscription-box-right-subscribe-btn:hover {
    cursor: pointer;
}

.home-container-header-subscription-box-right-subscribe-btn.clicked {
    background-color: #E3FFF6;
    color: #2CE8A3;
    pointer-events: none;
}

.home-container-header-subscription-box-right-subscribe-btn.clicked .home-container-header-subscription-box-right-subscribe-btn p {
    color: #11b677;
    font-weight: bold;
}

.home-container-header-subscription-box-right-subscribe-btn p {
    font-family: figtree;
    font-size: 13.75px; 
    margin-top: 0px;
    margin-bottom: 0px;
    cursor: pointer;
}

.home-container-header-subscription-box-right-subscribe-btn p:hover {
    cursor: pointer;
}

.home-container-header img {
    width: 8.5%;
}

.home-container-header h1 {
    // font-family: 'Momo Signature', cursive;
    font-family: stack sans headline;
    color: #2CE8A3;
}

    // - - HOME CONTAINER BODY - - //

.home-container-body {
    width:100%;
    flex: 1;
    border-top: 1px solid #ccc; 
    display: flex;
    flex-direction: row;
    // position: relative;
}
    // - - HOME CONTAINER MODAL ELEMENTS - - //

.modal-loading-container {
    width: 100%;
    height: 100%;
    // border: 1px solid black;
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-loading-container-spinner {
    margin-top: -15px;
    border: 3.5px solid rgba(0, 0, 0, 0.1); /* Light background for the spinner track */
    border-left-color: #2CE8A3; /* The main color for the spinning part */
    border-radius: 50%; /* Makes it a perfect circle */
    width: 20px; /* Adjust size as needed */
    height: 20px; /* Adjust size as needed */
    animation: spin 1s linear infinite; /* Apply the spin animation */
}

@keyframes spin {
  0% {
    transform: rotate(0deg); /* Start at 0 degrees */
  }
  100% {
    transform: rotate(360deg); /* Rotate a full 360 degrees */
  }
}
        // - SCHEDULE INTERVIEW CSS - //

/* Schedule Interview Modal */
.modal-schedule-interview-container {
  width: 100%;
//   max-width: 550px;
}

.modal-schedule-interview-container-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.modal-schedule-interview-container-header-left h1 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
}

.modal-schedule-interview-container-header-left h3 {
  margin: 0;
  font-size: 14px;
  color: #666;
  font-weight: 400;
}

.modal-schedule-interview-container-header-right img {
  width: 20px;
  height: 20px;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.modal-schedule-interview-container-header-right img:hover {
  opacity: 1;
}

.modal-schedule-interview-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 500;
  font-size: 14px;
}

.form-group label span {
  color: #333;
}

.form-group input {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-group input:focus {
  outline: none;
  border-color: #2D8CFF;
}

.form-group input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.modal-schedule-interview-info {
  background-color: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  border-left: 4px solid #2D8CFF;
}

.modal-schedule-interview-info p {
  margin: 6px 0;
  font-size: 13px;
  color: #555;
}

.modal-schedule-interview-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 10px;
}

.modal-schedule-interview-buttons button {
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancel {
  background-color: white;
  border: 1px solid #ccc !important;
  color: #333;
}

.btn-cancel:hover:not(:disabled) {
  background-color: #f5f5f5;
}

.btn-schedule {
  background-color: #2D8CFF;
  color: white;
}

.btn-schedule:hover:not(:disabled) {
  background-color: #1a7ae8;
}

.btn-schedule:disabled,
.btn-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

        // - REPORT JOB UI - //

.modal-report-ui-container-body {
    flex: 1;
    width: 100%;
    border-top: 1px solid #ccc;
    overflow-y: auto;
}

.modal-report-ui-container-body:after {
    content: '';
    clear: both;
    display: table;
}

.modal-report-ui-container-body-left {
    float: left;
    width: 50%;
    height: 100%;
    // border: 1px solid black;
    display: flex;
    flex-direction: column;
}

.modal-report-ui-container-body-left-header {
    border-bottom: 1px solid #ccc;
    height: 150px;
    width: 100%;
    text-align: left;
}

.modal-report-ui-container-body-left-header span { 
    text-decoration: underline;
    font-weight: normal;
    font-family: figtree;
    margin-right: 5.5px;
}

.modal-report-ui-container-body-left-header h4 { 
    margin-top: 10px;
    margin-bottom: 5px;
    padding-left: 10px;
    padding-right: 10px;
    font-weight: normal;
    font-family: figtree;
}


.modal-report-ui-container-body-left-header h3 { 
    margin-top: 0px;
    font-size: 17.5px;
    padding-left: 10px;
    padding-right: 10px;
    // font-family: figtree;
}

.modal-report-ui-container-body-left-body {
    flex: 1;
    width: 100%;
    // border: 1px solid red;
}

.modal-report-ui-container-body-left-body-report-cell {
    height: 15%;
    // border-bottom: 1px solid black;
    width: 100%;
    display: flex;
    flex-direction: row;
}

.modal-report-ui-container-body-left-body-report-cell-checkbox {
    width: 15%;
    // border: 1px solid black;
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-report-ui-container-body-left-body-report-cell-checkbox-container {
    width: 16.5px;
    height: 16.5px;
    border: 1px solid #999;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.2s ease;
}

.modal-report-ui-container-body-left-body-report-cell-checkbox-container:hover {
    transform: scale(1.05);
    cursor: pointer;
}

.modal-report-ui-container-body-left-body-report-cell-checkbox-container.selected {
    background-color: #2CE8A3;
    border: 1px solid #2CE8A3;
}

.modal-report-ui-container-body-left-body-report-cell-checkbox-container img {
    width: 16.5px;
    height: 16.5px;
}

.modal-report-ui-container-body-left-body-report-cell-description {
    width: 85%;
    // border: 1px solid black;
    display: flex;
    justify-content: left;
    align-items: center;
}

.modal-report-ui-container-body-left-body-report-cell-description p {
    font-family: figtree;
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 14.5px;
}

.modal-report-ui-container-body-left-body-report-cell-textarea {
    // border: 1px solid black;
    height: 40%;
    text-align: right;
    position: relative;
}



.modal-report-ui-container-body-left-body-report-cell-textarea span {
    // border: 1px solid black;
    position: absolute;
    top: -5%;
    right: 12.5px;
    text-align: center;
    padding-left: 1.5%;
    padding-right: 1.5%;
    background-color: white;
    height: auto;
    font-size: 11.5px;
    font-family: figtree;
}

.modal-report-ui-container-body-left-body-report-cell-textarea-counter-container {
    opacity: 0;
    transform: translateY(-9.5px);
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.modal-report-ui-container-body-left-body-report-cell-textarea-counter-container.visible {
    opacity: 1;
    transform: translateY(-6.5px);
}

.modal-report-ui-container-body-left-body-report-cell-textarea-counter {
    color: #ca244e;
}

.modal-report-ui-container-body-left-body-report-cell-textarea-counter.over-limit {
    color: #2CA3E8;
}

.modal-report-ui-container-body-left-body-report-cell-textarea textarea {
    width: 91.5%;
    height: 80.5%;
    resize: none;
    padding: 6.5px;
    outline: none;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-family: Helvetica Neue;
    font-size: 14.5px;
}

.modal-report-ui-container-body-right {
    float: left;
    height: 100%;
    width: 49.25%;
    // border: 1px solid black;
    display: flex;
    flex-direction: column;
}

.modal-report-ui-container-body-right-upper {
    height: 60%;
    // border: 1px solid black;
    display: flex;
    flex-direction: column;
}

.modal-report-ui-container-body-right-upper-header {
    height: 45%;
    // border: 1px solid black;
    display: flex;
    flex-direction: row;
}

.modal-report-ui-container-body-right-upper-header-left {
    width: 40%;
    // border: 1px solid black;
    text-align: left;
}

.modal-report-ui-container-body-right-upper-header-left h4 {
    margin-top: 9px;
    // margin-bottom: 5px;
    padding-left: 12px;
    padding-right: 10px;
    font-weight: normal;
    font-family: figtree;
    text-decoration: underline;
    font-weight: bold;
    font-size: 16.5px;
}

.modal-report-ui-container-body-right-upper-header-right {
    flex: 1;
    padding-top: 9px;  
    // border: 1px solid black;
}

.modal-report-reason-item-container {
    
}

.modal-report-reason-item {
    background: #E3FFF6;
    padding: 4px 12px;
    margin-bottom: 2.5px;
    border-radius: 3px;
    font-size: 11.75px;
    border: 1px solid #2CE8A3;
    font-family: figtree;
}

.modal-report-reason-item.few {
    padding: 10px 12px;
    font-size: 13px;
}

/* ENTER */
.modal-report-reason-item-container.enter {
    animation: slideUpFadeIn 220ms ease-out forwards;
}

/* EXIT */
.modal-report-reason-item-container.exit {
    animation: slideRightFadeOut 200ms ease-in forwards;
}

@keyframes slideUpFadeIn {
    from {
        opacity: 0;
        transform: translateY(12px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideRightFadeOut {
    from {
        opacity: 1;
        transform: translateX(0);
    }
    to {
        opacity: 0;
        transform: translateX(24px);
    }
}

.modal-report-ui-container-body-right-upper-body {
    flex: 1;
    border-top: 0.5px solid #ccc;
    border-bottom: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

.modal-report-ui-container-body-right-upper-body-top {
    height: 20%;
    // border-top: 0.5px solid #ccc;
    text-align: left;
    display: flex;
    justify-content: space-between;
}

.modal-report-ui-container-body-right-upper-body-top h4 {
    margin-top: 5px;
    // margin-bottom: 5px;
    padding-left: 12px;
    padding-right: 10px;
    font-weight: normal;
    font-family: figtree;
    text-decoration: underline;
    font-size: 15.5px;
}

.modal-report-ui-container-body-right-upper-body-top-label {
    width: 30%;
    margin-top: 1.5%;
    height: 65%;
    border: 0.5px solid #ca244e;
    border-radius: 5px;
    background-color: #ffdbe1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: figtree;
    font-size: 11.5px;
    color: #ca244e;
    opacity: 0;
    transform: translateX(-10px);
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.modal-report-ui-container-body-right-upper-body-top-label.visible {
    opacity: 1;
    transform: translateX(0);
}

.modal-report-ui-container-body-right-upper-body-bottom {
    flex: 1;
    text-align: left;
}


.modal-report-ui-container-body-right-upper-body-bottom p {
    margin-top: 5px;
    font-size: 14.5px;
    font-family: Helvetica Neue;
    padding-left: 12px;
    padding-right: 10px;
}

.modal-report-ui-container-body-right-lower {
    // border: 1px solid black;
    flex: 1;
    position: relative;
}


.modal-report-ui-container-body-right-lower-btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 52.5%;
    height: 25%;
    border-radius: 5px;
    background-color: #E3FFF6;
    border: 1px solid #2CE8A3;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: figtree;
    font-size: 14.5px;
    cursor: pointer;
}

.modal-report-ui-container-body-right-lower-btn:hover {
    border: 1px solid #707070;
}

.modal-report-ui-container-body-right-lower-btn.disabled {
    background-color: #f2f2f2;
    border: 1px solid #ccc;
    color: #ccc;
    pointer-events: none;
    cursor: not-allowed;
}

        // - CONSENT FORM UI - //

.modal-consent-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.modal-consent-container-header {
    height: 90px;
    width: 100%;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #ccc;
}

.modal-consent-container-header-left {
    width: 90%;
    padding-left: 10px;
    text-align: left;
}

.modal-consent-container-header-left h1 {
    font-family: figtree;
    margin-top: 15px;
    margin-bottom: 0px;
    font-size: 22px;
}

.modal-consent-container-header-left h3 {
    font-weight: normal;
    font-family: figtree;
    margin-top: 5px;
    margin-bottom: 0px;
    font-size: 13px;
    color: #707070;
}

.modal-consent-container-header-right {
    width: 10%;
    display: flex;
    justify-content: right;
    align-items: top;
}

.modal-consent-container-header-right img {
    width: 35px;
    height: 35px;
    padding: 3px;
    border-radius: 50%;
    filter: grayscale(100%) brightness(70%);
    margin-top: 5px;
}

.modal-consent-container-header-right img:hover {
    background-color: #f2f2f2;
    filter: grayscale(0);
    cursor: pointer;
}

.modal-consent-container-body {
    flex: 1;
    padding: 20px 15px;
    text-align: left;
}

.modal-consent-container-body p {
    font-family: figtree;
    font-size: 14.5px;
    color: #333;
    margin-top: 0px;
    margin-bottom: 10px;
    line-height: 1.5;
}

.modal-consent-container-body ul {
    margin-top: 5px;
    margin-bottom: 15px;
    padding-left: 20px;
}

.modal-consent-container-body li {
    font-family: figtree;
    font-size: 14.5px;
    color: #333;
    margin-bottom: 6px;
    line-height: 1.5;
}

.modal-consent-privacy-link {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
}

.modal-consent-container-footer {
    height: 70px;
    border-top: 1px solid #ccc;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding-right: 15px;
}

.modal-consent-container-footer-btn {
    height: 40px;
    padding: 0 20px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: figtree;
    font-size: 14px;
    cursor: pointer;
}

.modal-consent-container-footer-btn.decline {
    background-color: white;
    border: 1px solid #ccc;
    color: #333;
}

.modal-consent-container-footer-btn.decline:hover {
    background-color: #f2f2f2;
    border: 1px solid #707070;
}

.modal-consent-container-footer-btn.confirm {
    background-color: #2CE8A3;
    border: 1px solid #2CE8A3;
    color: black;
    font-weight: normal;
}

.modal-consent-container-footer-btn.confirm:hover {
    background-color: #E3FFF6;
    border: 1px solid #2CE8A3;
}

        // - SHARE JOB UI - //

.modal-share-ui-container {
    // border: 1px solid black;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.modal-share-ui-container-header {
    height: 105px;
    width: 100%;
    // border: 1px solid black;
    display: flex;
    flex-direction: row;
}

.modal-share-ui-container-header-left {
    width: 90%;
    // border: 1px solid black;
    padding-left: 10px;
    text-align: left;
}


.modal-share-ui-container-header-left h1 {
    font-family: figtree;
    margin-top: 20px;
    margin-bottom: 0px;
}

.modal-share-ui-container-header-left h3 {
    font-weight: normal;
    font-family: figtree;
    margin-top: 5px;
    margin-bottom: 0px;
}

.modal-share-ui-container-header-right {
    width: 10%;
    // border: 1px solid black;
    display: flex;
    justify-content: right;
    align-items: top;
}


.modal-share-ui-container-header-right img {
    width: 35px;
    height: 35px;
    padding: 3px;
    border-radius: 50%;
    filter: grayscale(100%) brightness(70%);
}


.modal-share-ui-container-header-right img:hover {
    background-color: #f2f2f2;
    filter: grayscale(0);
    cursor: pointer;
}

.modal-share-ui-container-body {
    flex: 1;
    width: 100%;
    border-top: 1px solid #ccc;
    overflow-y: auto;
}

.modal-share-ui-container-body:after {
    content: '';
    clear: both;
    display: table;
}

.modal-share-ui-container-body-left {
    width: 50%;
    height: 100%;
    float: left;
    // border: 1px solid #ccc;
    position: relative;
    display: flex;
    flex-direction: column;
}

.modal-share-ui-container-body-left-header { 
    border-bottom: 1px solid #ccc;
    // border-right: 1px solid #ccc;
    padding-left: 10px;
    padding-right: 10px;
    width: 94%;
    height: 150px;
    text-align: left;
    z-index: 2;
    background-color: white;
}


.modal-share-ui-container-body-left-header span { 
    text-decoration: underline;
    font-weight: normal;
    font-family: figtree;
    margin-right: 5.5px;
}

.modal-share-ui-container-body-left-header h4 { 
    margin-top: 10px;
    margin-bottom: 5px;
    font-weight: normal;
    font-family: figtree;
}


.modal-share-ui-container-body-left-header h3 { 
    margin-top: 0px;
    font-size: 17.5px;
    // font-family: figtree;
}

.modal-share-ui-container-body-left-body {
    text-align: left;
    border-bottom: 1px solid #ccc;
    position: absolute;
    bottom: 0;
    width: 97.5%;
    height: 63.5%;
    // height: 80%;
    z-index: 1;
    left: 10px;
    // border-radius: 15px;
    overflow-y: auto;
}


.modal-share-ui-container-body-left-body h3 {
    margin-top: 0px;
    font-size: 16px;
    font-weight: normal;
    // margin-left: 
}  


.modal-share-ui-container-body-left-body p {
    font-size: 14.5px;
    margin-top: 0px;
    // padding-right: 10px;
}


.leave-note-preview-text {
    white-space: pre-wrap;
}

.modal-share-ui-container-body-right {
    width: 49%;
    height: 100%;
    float: left;
    // border: 1px solid #ccc;
    background-color: white;
    display: flex;
    flex-direction: column;
    padding-left: 5px;
}

.modal-share-ui-container-body-right-upper {
    height: 30.5%;
    width: 96.75%;
    // border-bottom: 1px solid #ccc;
    text-align: left;
    padding-left: 5px;
    display: flex;
    flex-direction: column;
}

.modal-share-ui-container-body-right-upper span { 
    text-decoration: underline;
    font-weight: normal;
    font-family: figtree;
    margin-right: 5.5px;
}

.modal-share-ui-container-body-right-upper h4 { 
    margin-top: 7px;
    margin-bottom: 5px;
    font-weight: normal;
    font-family: figtree;
}

.modal-share-ui-container-body-right-upper textarea {
    flex: 1;
    // margin-bottom: 6px;
    margin-top: 3px;
    resize: none;
    padding: 8.5px;
    outline: none;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-family: Helvetica Neue;
    font-size: 14.5px;
}

.modal-share-ui-container-body-right-lower {
    flex: 1;
    // border: 1px solid #ccc;
    position: relative;
}

.modal-share-ui-container-body-right-lower-buttons-container {
    position: absolute;
    bottom: 40px;
    right: 0;
    // border: 1px solid black;
    text-align: right;
}

.modal-share-ui-container-body-right-lower-buttons-container-btn {
    float: right;
    background-color: #E3FFF6;
    margin-top: 15px;
    width: 80%;
    padding: 15px;
    display: flex;
    flex-direction: row;
    border-radius: 5px;
    border: 1px solid #2CE8A3;
}


.modal-share-ui-container-body-right-lower-buttons-container-btn.selected {
    background-color: white;
    border: 1px solid #2CE8A3;
}

.modal-share-ui-container-body-right-lower-buttons-container-btn.selected:hover {
    border: 1px solid #2CE8A3;
}

.modal-share-ui-container-body-right-lower-buttons-container-btn.selected .modal-share-ui-container-body-right-lower-buttons-container-btn-text p {
    text-decoration: underline;
}

.modal-share-ui-container-body-right-lower-buttons-container-btn:hover {
    border: 1px solid #707070;
    cursor: pointer;
}


.modal-share-ui-container-body-right-lower-buttons-container-btn:after {
    content: '';
    clear: both;
    display: table;
}

.modal-share-ui-container-body-right-lower-buttons-container-btn-icon {
    width: 10%;
    float: left;
    // border: 1px solid black;
    display: flex;
   justify-content: center;
   align-items: center;
}

.modal-share-ui-container-body-right-lower-buttons-container-btn-icon img {
    width: 65%;
}


.modal-share-ui-container-body-right-lower-buttons-container-btn-text {
   width: 90%;
   float: left;
//    border: 1px solid black;
   display: flex;
   justify-content: left;
   align-items: center;
}

.modal-share-ui-container-body-right-lower-buttons-container-btn-text p {
    margin-top: 0px;
    margin-left: 12.5px;
    text-align: left;
    margin-bottom: 0px;
    font-size: 13.5px;
    font-family: figtree;
}

    // - - HOME CONTAINER BODY PANELS - - //


    // - LEFT PANEL

.home-container-body-left-panel {
    width: 13%;
    // border-right: 1px solid #ccc;
    background-color: white;
    // border: 1px solid black;
    display: flex;
    flex-direction: column;
    height: 90%;
    position: relative;
    justify-content: center; /* centers horizontally */
    align-items: center;
    z-index: 2;
}

.home-container-body-left-panel-header {
    // border: 1px solid blue;
    flex: 1;
    width: 85%;
}

.home-container-body-left-panel-body {
    // flex; 1;
    // border: 1px solid red;
    width: 85%;
    height: calc(100% - 80px);
    display: flex;
    flex-direction: column;
}

.home-container-body-left-panel-body-top-section {
    border-top: 1px solid #ccc;
    height: 350px;
    padding-top: 5px;
    padding-bottom: 5px;
    width: 100%;
}

.home-container-body-left-panel-body-section-cell {
    // border: 1px solid black;
    border-radius: 8px;
    height: 45px;
    width: 100%;
    background-color: #E3FFF6;
    border: 1px solid #2CE8A3;
    cursor: pointer;
}

.home-container-body-left-panel-body-section-cell.selected {
    background-color: #E3FFF6; 
    border: 1px solid #2CE8A3;
    cursor: pointer;
}

.home-container-body-left-panel-body-section-cell:hover {
    background-color: #E3FFF6;
    border: 1px solid #2CE8A3;
    cursor: pointer;
}

.home-container-body-left-panel-body-section-cell:hover .home-container-body-left-panel-body-section-cell-text p {
    text-decoration: underline;
    font-weight: bold;
}

.home-container-body-left-panel-body-section-cell:after {
    content: '';
    display: block;
    clear: both;
}

.home-container-body-left-panel-body-section-cell-icon {
    width: 25%;
    // border-right: 1px solid black;
    height: 100%;
    float: left;
    display: flex;
    justify-content: center; /* centers horizontally */
    align-items: center;
}

.home-container-body-left-panel-body-section-cell-icon img {
    width: 55%;
}

.home-container-body-left-panel-body-section-cell-text {
    float: left;
    width: 73.5%;
    height: 100%;
    // border-right: 1px solid black;
    display: flex;
    justify-content: left; /* centers horizontally */
    align-items: center;
}

.home-container-body-left-panel-body-section-cell-text p {
    margin-top: -1.75px;
    margin-left: -1.5px;
    margin-bottom: 0px;
    font-size: 13px;
    font-family: figtree;
    // font-weight: bold;
    // text-decoration: underline;
    text-decoration: underline;
    font-weight: bold;
}

.home-container-body-left-panel-body-bottom-section {
    border-top: 1px solid #ccc;
    // flex: 1;
    height: 215px;
    width: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
}

.home-container-body-left-panel-footer {
    border-top: 1px solid #ccc;
    position: absolute;
    bottom: 0;
    height: 50px;
    width: 85%;
    text-align: center;
}

.home-container-body-left-panel-footer p {
    color: #707070;
    font-size: 13px;
    font-family: figtree;
    margin-top: 10px;
}
    // - CENTER PANEL - STUDY SESSIONS - //

.home-container-body-center-panel-study-session {
    position: absolute;
    width: 57%;
    height: 100%;
    border-right: 1px solid #ccc;   
    margin-left: 13%;
    background-color: white;
    z-index: 1;
    transition: transform 0.6s ease-out;
    transform: translateX(-100%);
    pointer-event: none;
}


.home-container-body-center-panel-study-session.visible {
    pointer-events: auto;
    z-index: 1;
    transform: translateX(0);
}

    // - CENTER PANEL

.home-container-body-center-panel {
    width: 57%;
    height: 100%;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;   
    position: relative;
    display: flex;
    flex-direction: column;
}

.home-container-body-center-panel-header {
    width: 100%;
    height: 150px;
    border-bottom: 0.5px solid #ccc;  
    display: flex;
    flex-direction: column;
}

.home-container-body-center-panel-header-search {
    width: 100%;
    height: 40%;
    // border: 1px solid pink; 
    position: relative;
    display: flex;
    justify-content: center;
}

.home-container-body-center-panel-header-search-box {
    width: 95%;
    height: 67.5%;
    border: 1px solid #999;  
    border-radius: 20px;
    position: absolute;
    bottom: 0;
}

.home-container-body-center-panel-header-search-box:after {
    content: '';
    display: block;
    clear: both;
}

.home-container-body-center-panel-header-search-box-left {
    float: left;
    width: 7%;
    height: 100%;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    // border: 1px solid black;
    display: flex;
    justify-content: center; /* centers horizontally */
    align-items: center;
}


.home-container-body-center-panel-header-search-box-left img {
    width: 28.5%;
}

.home-container-body-center-panel-header-search-box-center {
    float: left;
    width: 85%;
    height: 100%;
    // border: 1px solid black;
}

.home-container-body-center-panel-header-search-box-center input {
    height: 87.5%;
    font-size: 15.5px;
    padding-top: 0.3%;
    width: 100%;
    border: 1px solid transparent;
    outline: none;
    margin-left: -1%;
}

.home-container-body-center-panel-header-search-box-right {

}

.home-container-body-center-panel-header-btns {
    width: 100%;
    height: 60%;
    // border: 1px solid brown;   
    display: flex;                   /* enables flex layout */
    justify-content: space-between;  /* evenly distributes space */
    align-items: center;                
}

.home-container-body-center-panel-header-btns:after {
    content: '';
    display: block;
    clear: both;
}

.home-container-body-center-panel-header-btns-left {
    float: left;
    margin-top: 6.5px;
    width: 17.5%;
    border-right: 1px solid #ccc;
    height: 70%;
    display: flex;
    flex-direction: column;
    justify-content: center; /* centers horizontally */
    align-items: center;
}

.home-container-body-center-panel-header-btns-left h1 {
    font-weight: normal;
    margin-bottom: 0px;
    margin-top: 10px;
    font-size: 25px;
    color: #707070;
}

.home-container-body-center-panel-header-btns-left p {
    margin-top: 0px;
    font-size: 15px;
    color: #707070;
}

.home-container-body-center-panel-header-btns-right {
    // float: left;
    display: flex;                   /* enables flex layout */
    justify-content: space-between;  /* evenly distributes space */
    align-items: center;             /* vertically centers children */
    // width: 79.5%;
    flex: 1;
    height: 100%;
    // border: 1px solid black;
}

.home-container-body-center-panel-header-btns-right:after {
    content: '';
    display: block;
    clear: both;
}

.home-container-body-center-panel-header-btns-right-col {
    flex: 1;
    // width: 24%;
    height: 100%;
    // border: 1px solid black;
    display: flex;
    justify-content: right; /* centers horizontally */
    align-items: center;
    position: relative;
}

.home-container-body-center-panel-header-btns-right-col-btn {
    height: 35%;
    width: 80%;
    border: 1px solid #c9c9c9;
    border-radius: 20px;
    display: flex;
    justify-content: center; /* centers horizontally */
    align-items: center;
}

.home-container-body-center-panel-header-btns-right-col-btn:hover {
    cursor: pointer;
    border: 1px solid #707070;
}

.home-container-body-center-panel-header-btns-right-col-btn p {
    margin-top: -1px;
    margin-bottom: 0px;
    font-size: 13.5px;
}

.home-container-body-center-panel-header-btns-right-col-options {
    position: absolute;
    top: 80%;
    left: 20%;
    width: 350px;
    height: 200px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 10;

    opacity: 0;              /* hidden by default */
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.3s ease; /* smooth fade-in/out */
}

.home-container-body-center-panel-header-btns-right-col-options.visible {
    transform: translateY(0);
    opacity: 1;              
    visibility: visible;
}

.home-container-body-center-panel-body {
    width: 100%;
    // height: 70vh;
    flex: 1;
    // border: 2px solid blue; 
    position: relative;
}

.home-container-body-center-panel-body-job-posts {
    // height: 100vh;
    margin: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    overflow-y: auto;
}

.home-container-body-center-panel-body-job-post {
    height: 215px;
    border-bottom: 0.5px solid #ccc;
    display: flex;
    padding-botom: 50px;
}

.home-container-body-center-panel-body-job-post.selected { 
    background-color: #E3FFF6;
}

.home-container-body-center-panel-body-job-post:hover {
    background-color: #E3FFF6;
    cursor: pointer;
}

.home-container-body-center-panel-body-job-post:hover .home-container-body-center-panel-body-job-post-selected {
    background-color: #2CE8A3;
    cursor: pointer;
}

.home-container-body-center-panel-body-job-post.selected:hover .home-container-body-center-panel-body-job-post-selected {
    background-color: #2CE8A3;
    cursor: pointer;
}

.home-container-body-center-panel-body-job-post:hover .home-container-body-center-panel-body-job-post-details-top h2 {
    text-decoration: underline;
}

.home-container-body-center-panel-body-job-post:hover .home-container-body-center-panel-body-job-post-icon img {
    border: 1px solid #2CE8A3;
    cursor: pointer;
}

.home-container-body-center-panel-body-job-post.selected .home-container-body-center-panel-body-job-post-icon img {
   border: 1px solid #2CE8A3;
}

.home-container-body-center-panel-body-job-post.selected .home-container-body-center-panel-body-job-post-details-top h2 {
   text-decoration: underline;
}

.home-container-body-center-panel-body-job-post:after {
    content: '';
    display: block;
    clear: both;
}

.home-container-body-center-panel-body-job-post-selected {
    float: left;
    width: 0.65%;
    height: 100%;
    background-color: white;
}

.home-container-body-center-panel-body-job-post-selected.true {
    background-color: #2CE8A3;
}

.home-container-body-center-panel-body-job-post-icon {
    float: left;
    width: 16.35%;
    height: 100%;
    // border: 1px solid black;
    display: flex;
    justify-content: center; /* centers horizontally */
    align-items: center;
    flex-direction: column;
}

.home-container-body-center-panel-body-job-post-icon img {
    width: 50%;
    border-radius: 5px;
    border: 1px solid transparent;
    margin-top: 10%;
}

.home-container-body-center-panel-body-job-post-icon h5 {
    padding-left: 5px;
    padding-right: 5px;
    font-weight: normal;
    margin-top: 10px;
    font-size: 12.5px;
    // font-family: figtree;
}

.home-container-body-center-panel-body-job-post-details {
    float: left;
    flex: 1;
    height: 100%;
    // border: 1px solid black;
    text-align: left;
    padding-left: 5px;
    padding-right: 5px;
    display: flex;
    flex-direction: column;
    // justify-content: center;
}

.home-container-body-center-panel-body-job-post-details-top {
    min-height: 25%;
    width: 100%;
    // border: 1px solid black;
    position: relative;
}

.home-container-body-center-panel-body-job-post-details-top h2 {
    margin-top: 15px;
    margin-bottom: 0px;
    margin-left: 10px;
    // font-weight: normal;
    font-size: 18px;
    position: absolute;
    bottom: 0;
}

.home-container-body-center-panel-body-job-post-details-top h3 {
    position: absolute;
    bottom: 0;
    right: 2.5%;
    color: #707070;
    font-weight: normal;
    margin-bottom: 5px;
    font-size: 15px;
}

.home-container-body-center-panel-body-job-post-details-middle {
    height: 50%;
    width: 100%;
    // border: 1px solid black;
    position: relative;
    display: flex;
    flex-direction: row;
}

.home-container-body-center-panel-body-job-post-details-middle-left {
    width: 60%;
    height: 100%;
    // border: 1px solid black;
}

.home-container-body-center-panel-body-job-post-details-middle-left p {
    margin-left: 10px;
    margin-top: 5px;
    margin-bottom: 0px;
    font-size: 12px;
    font-weight: bold;
}
    
.home-container-body-center-panel-body-job-post-details-middle-left ul {
    margin-top: 5px;
    line-height: 1.4;
}

.home-container-body-center-panel-body-job-post-details-middle-left li {
    margin-left: -15px;
    margin-top: 2.5px;
    margin-bottom: 0px;
    font-size: 12px;
    font-family: figtree;
}

.home-container-body-center-panel-body-job-post-details-middle-right {
    width: 40%;
    height: 100%;
    // border: 1px solid black;
}

.home-container-body-center-panel-body-job-post-details-middle-right p {
    margin-left: 10px;
    margin-top: 5px;
    margin-bottom: 0px;
    font-size: 12px;
    font-weight: bold;
}

.home-container-body-center-panel-body-job-post-details-middle-right h4 {
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 2.5px;
    margin-bottom: 0px;
    font-size: 12px;
    font-weight: normal;
    font-family: figtree;
}

.home-container-body-center-panel-body-job-post-details-bottom {
    flex: 1;
    // border: 1px solid black;
    height: 100%;
}   

.home-container-body-center-panel-body-job-post-details-bottom h5 {
    margin-top: 30.5px;
    // margin-bottom: 0px;
    margin-left: 12.5px;
    font-weight: normal;
    color: #707070;
}

.home-container-body-center-panel-body-job-post-details-bottom h3 {
    visibility: hidden;
}

.job-board-loading {
    display: block;
    margin-left: auto;
    margin-right: auto;
    // margin-top: 50px;
}

    // - RIGHT PANEL

.home-container-body-right-panel {
    width: 30%;
    // border: 1px solid purple;
    display: flex;
    height: 100vh;
    flex-direction: column;
    z-index: 2;
}

.home-container-body-right-panel-body-top-header-right {
    max-height: 0px;
}

.home-container-body-right-panel-body-top-header-right-close-btn {
    visibility: hidden;
    pointer-events: none;
}

    // - - RIGHT PANEL - PLACEHOLDER - - //

.home-container-body-right-panel-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -100px;
    // padding: 40px;
    text-align: center;
    z-index: 1;
}

.home-container-body-right-panel-placeholder-icon {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: #E3FFF6;
    border: 1px solid #2CE8A3;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
}

.home-container-body-right-panel-placeholder-icon img {
    width: 40%;
    opacity: 0.6;
}

.home-container-body-right-panel-placeholder h2 {
    font-family: figtree;
    font-size: 20px;
    color: #333;
    margin-top: 0;
    margin-bottom: 10px;
}

.home-container-body-right-panel-placeholder p {
    font-family: figtree;
    font-size: 14px;
    color: #707070;
    line-height: 1.5;
    max-width: 300px;
    margin: 0;
}

    // - - RIGHT PANEL - JOB DETAILS - - //

.home-container-body-right-panel-body {
    height: calc(100% - 80px);
    // border: 1px solid red;
    display: flex;
    flex-direction: column;
}

.home-container-body-right-panel-body-top {
    height: 200px;
    // border: 1px solid black;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
}

.home-container-body-right-panel-body-top-header {
    height: 45%;
    // border: 1px solid black;
    text-align: left;
    display: flex;
    flex-direction: row;
}

.home-container-body-right-panel-body-top-header-left {
    width: 82.5%;
    // border: 1px solid black;
    display: flex;
    flex-direction: row;
    position: relative;
}

.home-container-body-right-panel-body-top-header-left img {
    height: 80%;
    max-width: 75px;
    // width: 80%;
    margin-top: 10px;
    margin-left: 10px;
    border: 1.5px solid #2CE8A3;
    border-radius: 8px;
}

.home-container-body-right-panel-body-top-header-left h3 {
    margin-left: 10px;
    margin-top: 10px;
    margin-bottom: 5px;
    font-size: 17px;
}

.home-container-body-right-panel-body-top-header-left p {
    position: absolute;
    bottom: 7.5px;
    margin-bottom: 0px;
    margin-left: 10px;
    font-size: 13.5px;
    color: #6563ff;
}

.home-container-body-right-panel-body-top-header-left p:hover {
    text-decoration: underline;
    cursor: pointer;
}

.home-container-body-right-panel-body-top-header-left-text span img {
    width: 14px;
    border: none;
    border-radius: 5.75px;
    margin-left: 2px;
    margin-bottom: -2px;
}

.home-container-body-right-panel-body-top-header-right {
    flex: 1;
    // border: 1px solid black;
    // position: relative;
    text-align: right;
}

.home-container-body-right-panel-body-top-header-right img {
    height: 25px;
    width: 25px;
    // padding-right: -2%;
    margin-top: 12.5px;
    margin-right: 10.5px;
    // border: 1px solid #2CE8A3;
    // border-radius: 50%;
    border-radius: 50%;
    padding: 3px;
}

.home-container-body-right-panel-body-top-header-right img:hover {
    background-color: #e6e6e6;
    border-radius: 50%;
    padding: 3px;
    cursor: pointer;
}

.home-container-body-right-panel-body-top-body-popup {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 70%;
    border: 1px solid #ccc;
    transition: transform 0.3s ease-out;
    transform: translateX(100%);
    // visibility: hidden;
    pointer-event: none;
    background-color: white;
    z-index: 1;
}


.home-container-body-right-panel-body-top-body-popup.visible {
    // visibility: visible;
    pointer-events: auto;
    transform: translateX(0);
}

.home-container-body-right-panel-body-top-body-popup-cell {
    width: 100%;
    border-bottom: 1px solid #ccc;
    height: 40%;
    display: flex;
    flex-direction: row;
}   

.home-container-body-right-panel-body-top-body-popup-cell:hover {
    background-color: #E3FFF6;
    cursor: pointer;
}


.home-container-body-right-panel-body-top-body-popup-cell:hover .home-container-body-right-panel-body-top-body-popup-cell-text p {
    text-decoration: underline;
    font-weight: bold;
}

.home-container-body-right-panel-body-top-body-popup-cell-icon {
    width: 15%;
    height: 100%;
    // border: 1px solid black;
    display: flex;
    align-items: center;
    justify-content: center;
}

.home-container-body-right-panel-body-top-body-popup-cell-icon img {
    width: 35%;
}

.home-container-body-right-panel-body-top-body-popup-cell-text {
    width: 85%;
    height: 100%;
    // border: 1px solid black;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: left;
}


.home-container-body-right-panel-body-top-body-popup-cell-text p {
    font-family: figtree;
    font-size: 16px;
    margin-top: -1px;
    margin-bottom: 0px;
}


.home-container-body-right-panel-body-top-body {
    flex: 1;
    // border: 1px solid black;
    position: relative;
    text-align: left;
    z-index; 0;
}

.home-container-body-right-panel-body-top-body h2 {
    margin-top: 5px;
    margin-left: 10px;
    margin-right: 10px;
    font-size: 22px;
}

.home-container-body-right-panel-body-top-body-job-details {
    position: absolute;
    bottom: 0;
    height: 35%;
    border-bottom: 1px solid #ccc;
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.home-container-body-right-panel-body-top-body-job-details p {
    margin-left: 10px;
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 14px;
}

.home-container-body-right-panel-body-top-body-job-details h4 {
    margin-right: 20px;
    font-weight: normal;
    margin-top: -0.5%;
    font-size: 18.5px;
    color: #707070;
}

.home-container-body-right-panel-body-bottom {
    flex: 1;
    // border: 1px solid purple;
    display: flex;
    position: relative;
    flex-direction: column;
    padding-bottom: 100px;
    overflow-y: auto;
}

.home-container-body-right-panel-body-bottom h3 {
    text-align: left;
    margin-left: 10px;
    margin-top: 12.5px;
    // font-weight: normal;
    font-size: 18px;
    // font-family: Figtree;
    text-decoration: underline;
}

.home-container-body-right-panel-body-bottom h4 {
    text-align: left;
    margin-left: 10px;
    margin-top: 0px;
    margin-bottom: 10px;
    margin-right: 10px;
    font-size: 16px;
    // font-weight: normal;
}

.home-container-body-right-panel-body-bottom p {
    text-align: left;
    margin-left: 10px;
    margin-top: 5px;
    margin-right: 10px;
    font-size: 16px;
    font-family: figtree;
    line-height: 1.5;
}

.home-container-body-right-panel-body-bottom ul {
    margin-top: 0px;
}   

.home-container-body-right-panel-body-bottom-header {
    width: 100%;    
    height: 35%;
    border: 1px solid black;
}


.home-container-body-right-panel-footer {
    position: absolute;
    background-color: white;
    bottom: 0;
    // flex: 1;
    width: 100%;
    height: 65px;
    border-top: 1px solid #ccc;
    display: flex;
    justify-content: center; /* centers horizontally */
    align-items: center;
}

.home-container-body-right-panel-footer button {
    position: absolute;
    left: 0;
    width: 28%;
    height: 65%;
    margin-left: 1%;
    border-radius: 5px;
    background-color: #2CE8A3;
    color: black;
    font-family: figtree;
    font-size: 16px;
    border: 1px solid #2CE8A3;
    // font-weight: bold;
    cursor: pointer;
}

.home-container-body-right-panel-footer button:disabled,
.home-container-body-right-panel-footer button.disabled {
    background-color: #f2f2f2;
    border: 1px solid #ccc;
    color: #ccc;
    cursor: not-allowed;
    pointer-events: none;
}

.home-container-body-center-panel-body-job-posts-loading-sentinel  {
    height: 20px;
    text-align: center;
}

    /* - - - - - - - - - - - - - - - - - - - - - Responsive Styles - - - - - - - - - - - - - - - - - - - - - */


/* Extra Small Mobile (320px - 575px) */
@media (max-height: 453px) {

    .home-container-header {
        min-height: 90px;
    }
}

/* Extra Small Mobile (320px - 575px) */
@media (max-width: 575px) {

    // - TERMS OF SERVICE / PRIVACY POLICY - //

    .big-screen-links {
        position: absolute;
        top: 4px; /* ✅ Push down below the email address */
        left: 0;
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-left: 0;
        z-index: 999;
    }

    .big-screen-links p {
        margin: 0; /* ✅ Remove margins */
        font-family: figtree;
        font-size: 10.5px; /* ✅ Slightly smaller */
        color: blue;
        margin-right: 10px; /* ✅ Add some spacing from the right edge */
        margin-left: 10px; /* ✅ Add some spacing from the right edge */
    }

    .big-screen-links p:hover {
        cursor: pointer;
        text-decoration: underline;
    }

        // - NOTIFICATION MODAL - //  

    .notificationModal {
        position: absolute;
        top: 0.8%;
        left: 0.5%;
        width: 77.5%;
        height: 75px;
        background-color: white;
        border: 1.25px solid #11b677;
        z-index: 1000;
        transform: translateX(-150%);
        transition: transform 0.8s ease;
    }

        // - REPORT MODAL - //

    .modal-share-ui-container-header-left h1 {
        font-family: figtree;
        margin-top: 20px;
        margin-bottom: 0px;
    }

    .modal-share-ui-container-header-left h3 {
        font-size: 14px;
        font-weight: normal;
        font-family: figtree;
        margin-top: 5px;
        margin-bottom: 0px;
    }

    .modal-report-ui-container-body-left-header h4 { 
        margin-top: 10px;
        margin-bottom: 5px;
        font-size: 14px;
        padding-left: 10px;
        padding-right: 10px;
        font-weight: normal;
        font-family: figtree;
    }

    .modal-report-ui-container-body-left-header h3 { 
        margin-top: 0px;
        font-size: 15.5px;
        padding-left: 10px;
        padding-right: 10px;
        // font-family: figtree;
    }

    .modal-report-ui-container-body-left-body-report-cell-description p {
        font-family: figtree;
        margin-top: 0px;
        margin-bottom: 0px;
        font-size: 12.5px;
    }

        // - SHARE MODAL - //

    .modal-share-ui-container-body-left-header h4 { 
        margin-top: 10px;
        margin-bottom: 5px;
        font-size: 14px;
        padding-left: 10px;
        padding-right: 10px;
        font-weight: normal;
        font-family: figtree;
    }

    .modal-share-ui-container-body-left-header h3 { 
        margin-top: 0px;
        font-size: 15.5px;
        padding-left: 10px;
        padding-right: 10px;
        // font-family: figtree;
    }

    .modal-share-ui-container-body-right-lower-buttons-container-btn {
        float: right;
        background-color: #E3FFF6;
        margin-top: 15px;
        width: 90%;
        padding: 15px;
        display: flex;
        flex-direction: row;
        border-radius: 5px;
        border: 1px solid #2CE8A3;
    }

    .modal-share-ui-container-body-right-lower-buttons-container-btn-text p {
        margin-top: 0px;
        margin-left: 12.5px;
        text-align: left;
        margin-bottom: 0px;
        font-size: 12.5px;
        font-family: figtree;
    }

        // - PAGE HEADER - //

    .home-container-header img {
        position: absolute;
        left: 0;
        width: 0%;
        visibility: hidden;
    }

    .home-container-header h4 {
        bottom: auto;
        top: 3px; /* Position from top instead */
        left: 50%;
        transform: translateX(-50%); /* Center it */
        font-size: 11px;
        font-family: figtree;
        font-weight: normal;
        margin: 0;
    }

    .home-container-header-subscription-box {
        width: 98%;
    }

    .home-container-header-subscription-box h5 {
        font-size: 12.5px;
        margin-top: 24px;
    }

    .home-container-header-subscription-box-left-email-box {
        position: absolute;
        height: 50%;
        // border: 1px solid black;
        width: 100%;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: top;
    }

    .home-container-header-subscription-box-right-subscribe-btn-box {
        position: absolute;
        height: 50%;
        // border: 1px solid black;
        width: 100%;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: top;
    }

    .home-container-header-subscription-box-right-subscribe-btn {
        position: absolute;
        top: -0.75px;
        width: 90%;
        height: 80%;
        border: 1.95px solid #2CE8A3;
        background-color: #2CE8A3;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        padding-bottom: 1%;
    }

    // - SHARE MODAL CONTAINER - //

    .modal-share-ui-container-body-left {
        width: 100%;
        height: 100%;
        float: left;
        // border: 1px solid #ccc;
        position: relative;
        display: flex;
        flex-direction: column;
    }

    .modal-share-ui-container-body-right {
        width: 100%;
        height: 100%;
        float: left;
        // border: 1px solid #ccc;
        position: relative;
        display: flex;
        flex-direction: column;
    }

    .modal-share-ui-container-body-right-upper h4 { 
        margin-top: 15px;
        margin-bottom: 5px;
        font-weight: normal;
        font-family: figtree;
    }

    .modal-share-ui-container-body-right-lower-buttons-container {
        position: absolute;
        bottom: 40px;
        right: 5%;
        // border: 1px solid black;
        text-align: right;
    }

    .modal-share-ui-container-body-right-lower-buttons-container-btn {
        float: right;
        background-color: #E3FFF6;
        margin-top: 15px;
        width: 75%;
        padding: 15px;
        display: flex;
        flex-direction: row;
        border-radius: 5px;
        border: 1px solid #2CE8A3;
    }

    // - REPORT MODAL CONTAINER - //

    .modal-report-ui-container-body-left {
         width: 100%;
    }

    .modal-report-ui-container-body-right {
         width: 100%;
         margin-top: 20px;
    }

    // - LEFT PANEL - //

    .home-container-body-left-panel {
        width: 0%;
        // border-right: 1px solid #ccc;
        background-color: white;
        // border: 1px solid black;
        display: flex;
        flex-direction: column;
        height: 90%;
        position: relative;
        justify-content: center; /* centers horizontally */
        align-items: center;
        z-index: 2;
    }

    .home-container-body-left-panel-body-section-cell {
        // border: 1px solid black;
        border-radius: 8px;
        height: 45px;
        width: 100%;
        background-color: #E3FFF6;
        border: 1px solid transparent;
        cursor: pointer;
    }

    .home-container-body-left-panel-body-section-cell-icon {
        width: 100%;
        // border-right: 1px solid black;
        height: 100%;
        float: left;
        display: flex;
        justify-content: center; /* centers horizontally */
        align-items: center;
    }

    .home-container-body-left-panel-body-section-cell-icon img {
        width: 50%;
        margin-left: -5%;
    }

    .home-container-body-left-panel-body-section-cell-text {
        float: left;
        width: 0%;
        height: 100%;
        // border-right: 1px solid black;
        display: flex;
        justify-content: left; /* centers horizontally */
        align-items: center;
    }

    .home-container-body-left-panel-body-section-cell-text p {
        margin-top: -1.75px;
        margin-left: -5%;
        margin-bottom: 0px;
        font-size: 0px;
        font-family: figtree;
        // font-weight: bold;
        // text-decoration: underline;
    }

    .home-container-body-center-panel-study-session {
        position: absolute;
        width: 57%;
        height: 100%;
        border-right: 1px solid #ccc;   
        margin-left: 13%;
        background-color: white;
        z-index: 1;
        transition: transform 0.6s ease-out;
        transform: translateX(-200%);
        pointer-event: none;
    }

    .home-container-body-left-panel-footer p {
        color: #707070;
        font-size: 0px;
        font-family: figtree;
        margin-top: 10px;
    }

        // - CENTER PANEL - //

    .job-board-loading {
        margin-left: 35.5vw;
        margin-right: 30.5vw;
    }

    .home-container-body-center-panel {
        width: 100%;
        height: 100%;
        border-right: 1px solid #ccc;   
        position: relative;
        display: flex;
        flex-direction: column;
        z-index: 1;
    }

    .home-container-body-center-panel-header {
        width: 100%;
        height: 100px;
        border-bottom: 0.5px solid #ccc;  
        display: flex;
        flex-direction: column;
    }

    .home-container-body-center-panel-header-search {
        width: 100%;
        height: 50%;
        // border: 1px solid pink; 
        position: relative;
        display: flex;
        justify-content: center;
    }

    .home-container-body-center-panel-header-search-box {
        width: 95%;
        height: 68.5%;
        padding-top: 0.8%;
        border: 1px solid #999;  
        border-radius: 20px;
        position: absolute;
        top: 19.5%;
    }

    .home-container-body-center-panel-header-search-box:after {
        content: '';
        display: block;
        clear: both;
    }

    .home-container-body-center-panel-header-search-box-left {
        float: left;
        width: 10%;
        height: 100%;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        // border: 1px solid black;
        display: flex;
        justify-content: center; /* centers horizontally */
        align-items: center;
    }


    .home-container-body-center-panel-header-search-box-left img {
        width: 40.5%;
        margin-top: -10%;
    }

    .home-container-body-center-panel-header-search-box-center {
        float: left;
        width: 85%;
        height: 100%;
        // border: 1px solid black;
    }

    .home-container-body-center-panel-header-search-box-center input {
        height: 75.5%;
        font-size: 15.5px;
        padding-top: 0.3%;
        // padding-bottom: -0.2%;
        width: 95%;
        border: 1px solid transparent;
        outline: none;
        margin-left: -1%;
    }

    .home-container-body-center-panel-header-search-box-right {

    }

    .home-container-body-center-panel-header-btns {
        width: 100%;
        height: 40%;
        // border: 1px solid brown;   
        display: flex;                   /* enables flex layout */
        justify-content: space-between;  /* evenly distributes space */
        align-items: center;                
    }

    .home-container-body-center-panel-header-btns-left {
        float: left;
        margin-top: 6.5px;
        width: 20%;
        border-right: 1px solid #ccc;
        height: 70%;
        display: flex;
        flex-direction: column;
        justify-content: center; /* centers horizontally */
        align-items: center;
    }

    .home-container-body-center-panel-header-btns-left h1 {
        font-weight: normal;
        margin-bottom: 0px;
        margin-top: 10px;
        font-size: 16px;
        color: #707070;
    }

    .home-container-body-center-panel-header-btns-left p {
        margin-top: 0px;
        font-size: 11px;
        color: #707070;
    }

    .home-container-body-center-panel-header-btns-right {
        // float: left;
        display: flex;                   /* enables flex layout */
        justify-content: space-between;  /* evenly distributes space */
        align-items: center;             /* vertically centers children */
        // width: 79.5%;
        flex: 1;
        height: 100%;
        // border: 1px solid black;
    }

    .home-container-body-center-panel-header-btns-right-col {
        flex: 1;
        // width: 24%;
        height: 100%;
        // border: 1px solid black;
        display: flex;
        justify-content: right; /* centers horizontally */
        align-items: center;
        position: relative;
    }

    .home-container-body-center-panel-header-btns-right-col-btn {
        height: 65%;
        margin-top: 7.5%;
        width: auto;
        padding-left: 12.5%;
        padding-right: 12.5%;
        margin-left: 10%;
        margin-right: -18vw;
    }

    .home-container-body-center-panel-header-btns-right-col-btn p {
        font-size: 10px;
    }

    .home-container-body-center-panel-header-btns-right-col-options {
        position: absolute;
        top: 80%;
        left: 10%;
        width: 350px;
        height: 200px;
        border: 1px solid #ccc;
        border-radius: 5px;
        background-color: white;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        z-index: 10;

        opacity: 0;              /* hidden by default */
        visibility: hidden;
        transform: translateY(-10px);
        transition: all 0.3s ease; /* smooth fade-in/out */
    }

    .home-container-body-center-panel-header-btns-right-col-options.visible {
        transform: translateY(0);
        opacity: 1;              
        visibility: visible;
    }
    
    .home-container-body-center-panel-body-job-post {
        height: auto;
        display: flex;
        flex-direction: column;
    }

    .home-container-body-center-panel-body-job-post-icon {
        float: left;
        width: 100%;
        height: 100%;
        // border: 1px solid black;
        display: flex;
        justify-content: center; /* centers horizontally */
        align-items: center;
        flex-direction: column;
    }

    .home-container-body-center-panel-body-job-post-icon img {
        width: 15%;
        border-radius: 5px;
        border: 1px solid transparent;
        margin-top: 5%;
        // margin-left: 17.5%;
    }

    .home-container-body-center-panel-body-job-post-icon h5 {
        padding-left: 5px;
        padding-right: 5px;
        font-weight: normal;
        margin-top: 6.5px;
        font-size: 12.5px;
        // font-family: figtree;
        // margin-left: 17.5%;
    }

    .home-container-body-center-panel-body-job-post-details {
        // flex: 1;
        height: 100%;
        // border: 1px solid black;
        text-align: left;
        padding-left: 5px;
        padding-right: 5px;
        margin-top: 8.5%;
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
    }

    .home-container-body-center-panel-body-job-post-details-top h2 {
        // font-size: px;
    }

    .home-container-body-center-panel-body-job-post-details-top h3 {
        visibility: hidden;
    }

    .home-container-body-center-panel-body-job-post-details-middle {
        height: auto;
        width: 100%;
        // border: 1px solid black;
        display: flex;
        flex-direction: column;
    }


    .home-container-body-center-panel-body-job-post-details-middle-left {
        width: 100%;
        height: 100%;
        // border: 1px solid black;
    }

    .home-container-body-center-panel-body-job-post-details-middle-left p {
        margin-left: 10px;
        // margin-right: 10px;
        margin-top: 5px;
        margin-bottom: 0px;
        font-size: 12px;
        font-weight: bold;
    }
        
    .home-container-body-center-panel-body-job-post-details-middle-left ul {
        margin-top: 5px;
        line-height: 1.4;
    }

    .home-container-body-center-panel-body-job-post-details-middle-left li {
        margin-left: -15px;
        margin-right: 15px;
        margin-top: 2.5px;
        margin-bottom: 0px;
        font-size: 12px;
        font-family: figtree;
    }

    .home-container-body-center-panel-body-job-post-details-middle-right {
        width: 100%;
        height: 100%;
        // border: 1px solid black;
    }

    .home-container-body-center-panel-body-job-post-details-middle-right p {
        margin-left: 10px;
        margin-top: 5px;
        margin-bottom: 0px;
        font-size: 12px;
        font-weight: bold;
    }

    .home-container-body-center-panel-body-job-post-details-middle-right h4 {
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 2.5px;
        margin-bottom: 0px;
        font-size: 12px;
        font-weight: normal;
        font-family: figtree;
    }

    .home-container-body-center-panel-body-job-post-details-bottom {
       position: relative;
    }

    .home-container-body-center-panel-body-job-post-details-bottom h5 {
        margin-top: 43.5px;
        // margin-bottom: 0px;
        margin-left: 12.5px;
        font-weight: normal;
        color: #707070;
    }

    .home-container-body-center-panel-body-job-post-details-bottom h3 {
       position: absolute;
        bottom: 10%;
        right: 2.5%;
        color: #707070;
        font-weight: normal;
        // margin-bottom: 5px;
        font-size: 13.5px;
        visibility: visible;
    }

    .home-container-body-center-panel-body-job-posts-loading-sentinel  {
        height: 5px;
    }

    /* --- RIGHT PANEL: Positioned for full overlay slide-in --- */

    .home-container-body-right-panel-body-top-header-right {
        max-height: 20px;
    }

    .home-container-body-right-panel-body-top-header-right-close-btn {
        // visibility: visible;
        // pointer-events: auto;
    }

    .home-container-body-right-panel-body-top-body h2 {
        font-size: 18px;
    }

    .home-container-body-right-panel-body-top-body-job-details p {
        font-size: 12.5px;
    }

    .home-container-body-right-panel-body-top-body-job-details h4 {
        margin-top: -0.15%;
        margin-right: 2.5%;
        font-size: 13.5px;
    }

    .home-container-body-right-panel {
        /* This panel needs to be positioned relative to the viewport/main container, */
        /* so it overlaps the Center Panel. */
        position: fixed; /* Use fixed or absolute relative to the main container */
        top: 0;
        right: 0;
        width: 82.5%; /* Decide on the width for the slide-in details (e.g., 60% of the screen) */
        height: 100vh;
        
        /* The crucial change: higher z-index for overlay */
        z-index: 1000; /* Ensures it appears clearly over everything else */
        
        background-color: white; 
        border-left: 1px solid #ccc; 
        
        /* Initial state: off-screen (to the right) */
        transform: translateX(100%);
        transition: transform 0.3s ease-out;
        pointer-events: none; 
    }

    /* --- RIGHT PANEL: Active state (triggered when job is clicked) --- */
    .home-container-body-right-panel.active {
        transform: translateX(0); /* Slides into view */
        pointer-events: auto; 
    }

    /* --- NEW: Backdrop CSS --- */
    .home-container-backdrop {
        /* Fixed positioning to cover the whole viewport */
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        
        /* Must be visible but below the sliding panel (z-index 100) */
        z-index: 90;
        
        /* Dimming effect (semi-transparent black) */
        background-color: rgba(0, 0, 0, 0.5); 

        /* Hidden by default */
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease; /* Smooth fade-in/out */
        pointer-events: none; /* Crucial: ensures clicks pass through when hidden */
    }

    .home-container-backdrop.visible {
        opacity: 1;
        visibility: visible;
        pointer-events: auto; /* Enable closing click when visible */
    }

    .home-container-body-right-panel-body-bottom {
        flex: 1;
        // border: 1px solid purple;
        display: flex;
        position: relative;
        flex-direction: column;
        padding-bottom: 30px;
        overflow-y: auto;
    }

    .home-container-body-right-panel-footer button {
        position: absolute;
        left: 0;
        width: 96%;
        height: 65%;
        margin-left: 2%;
        border-radius: 5px;
        background-color: #2CE8A3;
        color: black;
        font-family: figtree;
        font-size: 16px;
        border: 1px solid #2CE8A3;
        // font-weight: bold;
        cursor: pointer;
    }
 
}

/* Small Mobile/Mobile Landscape (576px - 767px) */
@media (min-width: 576px) and (max-width: 767px) {

        // - TERMS OF SERVICE / PRIVACY POLICY - //

    .big-screen-links {
        position: absolute;
        top: 0;
        left: 0;
        width: 35%;
        height: 3.5%;
        display: flex;
        flex-direction: row;
        // border: 1px solid black;
        align-items: center;
        padding-left: 0.6%;
        z-index: 999;
    }

    .big-screen-links p {
        margin-right: 5%;
        font-family: figtree;
        font-size: 11.5px;
        color: blue;
    }

    .big-screen-links p:hover {
        cursor: pointer;
        text-decoration: underline;
    }

        // - NOTIFICATION MODAL - //  

    .notificationModal {
        position: absolute;
        top: 0.8%;
        left: 0.5%;
        width: 35%;
        height: 75px;
        background-color: white;
        border: 1.25px solid #11b677;
        z-index: 1000;
        transform: translateX(-150%);
        transition: transform 0.8s ease;
    }

        // - PAGE HEADER - //

    .home-container-header img {
        position: absolute;
        left: 0;
        width: 14.5%;
    }

    .home-container-header h4 {
        bottom: 5%;
        left: 1%;
        font-size: 12px;
        font-family: figtree;
        font-weight: normal;
    }

    .home-container-header-subscription-box {
        width: 60%;
    }

    // - SHARE MODAL CONTAINER - //

    .modal-share-ui-container-body-left {
        width: 100%;
        height: 100%;
        float: left;
        // border: 1px solid #ccc;
        position: relative;
        display: flex;
        flex-direction: column;
    }

    .modal-share-ui-container-body-right {
        width: 100%;
        height: 100%;
        float: left;
        // border: 1px solid #ccc;
        position: relative;
        display: flex;
        flex-direction: column;
    }

    .modal-share-ui-container-body-right-upper h4 { 
        margin-top: 15px;
        margin-bottom: 5px;
        font-weight: normal;
        font-family: figtree;
    }

    .modal-share-ui-container-body-right-lower-buttons-container {
        position: absolute;
        bottom: 40px;
        right: 5%;
        // border: 1px solid black;
        text-align: right;
    }

    .modal-share-ui-container-body-right-lower-buttons-container-btn {
        float: right;
        background-color: #E3FFF6;
        margin-top: 15px;
        width: 75%;
        padding: 15px;
        display: flex;
        flex-direction: row;
        border-radius: 5px;
        border: 1px solid #2CE8A3;
    }

    // - REPORT MODAL CONTAINER - //

    .modal-report-ui-container-body-left {
         width: 100%;
    }

    .modal-report-ui-container-body-right {
         width: 100%;
         margin-top: 20px;
    }

    // - LEFT PANEL - //

    .home-container-body-left-panel {
        width: 0%;
        // border-right: 1px solid #ccc;
        background-color: white;
        // border: 1px solid black;
        display: flex;
        flex-direction: column;
        height: 90%;
        position: relative;
        justify-content: center; /* centers horizontally */
        align-items: center;
        z-index: 2;
    }

    .home-container-body-left-panel-body-section-cell {
        // border: 1px solid black;
        border-radius: 8px;
        height: 45px;
        width: 100%;
        background-color: #E3FFF6;
        border: 1px solid transparent;
        cursor: pointer;
    }

    .home-container-body-left-panel-body-section-cell-icon {
        width: 100%;
        // border-right: 1px solid black;
        height: 100%;
        float: left;
        display: flex;
        justify-content: center; /* centers horizontally */
        align-items: center;
    }

    .home-container-body-left-panel-body-section-cell-icon img {
        width: 45%;
    }

    .home-container-body-left-panel-body-section-cell-text {
        float: left;
        width: 0%;
        height: 100%;
        // border-right: 1px solid black;
        display: flex;
        justify-content: left; /* centers horizontally */
        align-items: center;
    }

    .home-container-body-left-panel-body-section-cell-text p {
        margin-top: -1.75px;
        margin-left: -1.5px;
        margin-bottom: 0px;
        font-size: 0px;
        font-family: figtree;
        // font-weight: bold;
        // text-decoration: underline;
    }

    .home-container-body-center-panel-study-session {
        position: absolute;
        width: 57%;
        height: 100%;
        border-right: 1px solid #ccc;   
        margin-left: 13%;
        background-color: white;
        z-index: 1;
        transition: transform 0.6s ease-out;
        transform: translateX(-200%);
        pointer-event: none;
    }

    .home-container-body-left-panel-footer p {
        color: #707070;
        font-size: 0px;
        font-family: figtree;
        margin-top: 10px;
    }

        // - CENTER PANEL - //

        .job-board-loading {
            margin-left: 37.5vw;
            margin-right: 37.5vw;
        }

    .home-container-body-center-panel {
        width: 100%;
        height: 100%;
        border-right: 1px solid #ccc;   
        position: relative;
        display: flex;
        flex-direction: column;
        z-index: 1;
    }

    .home-container-body-center-panel-header-btns-right-col-btn {
        width: 90%;
    }

    .home-container-body-center-panel-header-btns-right-col-btn p {
        font-size: 11.25px;
    }

    .home-container-body-center-panel-header-btns-right-col-options {
        position: absolute;
        top: 80%;
        left: 10%;
        width: 350px;
        height: 200px;
        border: 1px solid #ccc;
        border-radius: 5px;
        background-color: white;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        z-index: 10;

        opacity: 0;              /* hidden by default */
        visibility: hidden;
        transform: translateY(-10px);
        transition: all 0.3s ease; /* smooth fade-in/out */
    }

    .home-container-body-center-panel-header-btns-right-col-options.visible {
        transform: translateY(0);
        opacity: 1;              
        visibility: visible;
    }
    
    .home-container-body-center-panel-body-job-post {
        height: 295px;
    }

    .home-container-body-center-panel-body-job-post-icon {
        float: left;
        width: 16.35%;
        height: 100%;
        // border: 1px solid black;
        display: flex;
        justify-content: center; /* centers horizontally */
        align-items: center;
        flex-direction: column;
    }

    .home-container-body-center-panel-body-job-post-icon img {
        width: 55%;
        border-radius: 5px;
        border: 1px solid transparent;
        margin-top: 10%;
        margin-left: 17.5%;
    }

    .home-container-body-center-panel-body-job-post-icon h5 {
        padding-left: 5px;
        padding-right: 5px;
        font-weight: normal;
        margin-top: 10px;
        font-size: 12.5px;
        // font-family: figtree;
        margin-left: 17.5%;
    }

    .home-container-body-center-panel-body-job-post-details-top h3 {
        bottom: 40px;
    }

    .home-container-body-center-panel-body-job-post-details-bottom h5 {
        margin-top: 43.5px;
        // margin-bottom: 0px;
        margin-left: 12.5px;
        font-weight: normal;
        color: #707070;
    }

    .home-container-body-center-panel-body-job-posts-loading-sentinel  {
        height: 5px;
    }

    /* --- RIGHT PANEL: Positioned for full overlay slide-in --- */

    .home-container-body-right-panel-body-top-header-right {
        max-height: 20px;
    }

    .home-container-body-right-panel-body-top-header-right-close-btn {
        // visibility: visible;
        // pointer-events: auto;
    }

    .home-container-body-right-panel-body-top-body-job-details h4 {
        margin-top: -0.75%;
        font-size: 15.5px;
    }

    .home-container-body-right-panel {
        /* This panel needs to be positioned relative to the viewport/main container, */
        /* so it overlaps the Center Panel. */
        position: fixed; /* Use fixed or absolute relative to the main container */
        top: 0;
        right: 0;
        width: 75%; /* Decide on the width for the slide-in details (e.g., 60% of the screen) */
        height: 100vh;
        
        /* The crucial change: higher z-index for overlay */
        z-index: 1000; /* Ensures it appears clearly over everything else */
        
        background-color: white; 
        border-left: 1px solid #ccc; 
        
        /* Initial state: off-screen (to the right) */
        transform: translateX(100%);
        transition: transform 0.3s ease-out;
        pointer-events: none; 
    }

    /* --- RIGHT PANEL: Active state (triggered when job is clicked) --- */
    .home-container-body-right-panel.active {
        transform: translateX(0); /* Slides into view */
        pointer-events: auto; 
    }

    /* --- NEW: Backdrop CSS --- */
    .home-container-backdrop {
        /* Fixed positioning to cover the whole viewport */
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        
        /* Must be visible but below the sliding panel (z-index 100) */
        z-index: 90;
        
        /* Dimming effect (semi-transparent black) */
        background-color: rgba(0, 0, 0, 0.5); 

        /* Hidden by default */
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease; /* Smooth fade-in/out */
        pointer-events: none; /* Crucial: ensures clicks pass through when hidden */
    }

    .home-container-backdrop.visible {
        opacity: 1;
        visibility: visible;
        pointer-events: auto; /* Enable closing click when visible */
    }

    .home-container-body-right-panel-body-bottom {
        flex: 1;
        // border: 1px solid purple;
        display: flex;
        position: relative;
        flex-direction: column;
        padding-bottom: 30px;
        overflow-y: auto;
    }

    .home-container-body-right-panel-footer button {
        position: absolute;
        left: 0;
        width: 96%;
        height: 65%;
        margin-left: 2%;
        border-radius: 5px;
        background-color: #2CE8A3;
        color: black;
        font-family: figtree;
        font-size: 16px;
        border: 1px solid #2CE8A3;
        // font-weight: bold;
        cursor: pointer;
    }

}

/* Multiple conditions with AND */
@media (min-width: 768px) and (max-width: 1024px) { 

        // - - NOTIFICATION MODAL - //

    .notificationModal {
        position: absolute;
        top: 0.8%;
        left: 0.5%;
        width: 35%;
        height: 75px;
        background-color: white;
        border: 1.25px solid #11b677;
        z-index: 1000;
        transform: translateX(-150%);
        transition: transform 0.8s ease;
    }

        // - HEADER - //

    .home-container-header img {
        width: 11%;
    }

    .home-container-header-subscription-box {
        width: 40%;
    }

    .home-container-header-subscription-box h5 {
        font-size: 12.5px;
        margin-top: 20px;
    }

    .home-container-header-subscription-box-left-email-box {
        position: absolute;
        height: 55%;
        // border: 1px solid black;
        width: 100%;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: top;
    }

    .home-container-header-subscription-box-right-subscribe-btn-box {
        position: absolute;
        height: 55%;
        // border: 1px solid black;
        width: 100%;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: top;
    }

        // - LEFT PANEL - //

    .home-container-body-left-panel {
        width: 6.5%;
        // border-right: 1px solid #ccc;
        background-color: white;
        // border: 1px solid black;
        display: flex;
        flex-direction: column;
        height: 90%;
        position: relative;
        justify-content: center; /* centers horizontally */
        align-items: center;
        z-index: 2;
    }

    .home-container-body-left-panel-body-section-cell-icon {
        width: 100%;
        // border-right: 1px solid black;
        height: 100%;
        float: left;
        display: flex;
        justify-content: center; /* centers horizontally */
        align-items: center;
    }

    .home-container-body-left-panel-body-section-cell-icon img {
        width: 45%;
    }

    .home-container-body-left-panel-body-section-cell-text {
        float: left;
        width: 0%;
        height: 100%;
        // border-right: 1px solid black;
        display: flex;
        justify-content: left; /* centers horizontally */
        align-items: center;
    }

    .home-container-body-left-panel-body-section-cell-text p {
        margin-top: -1.75px;
        margin-left: -1.5px;
        margin-bottom: 0px;
        font-size: 0px;
        font-family: figtree;
        // font-weight: bold;
        // text-decoration: underline;
    }

    .home-container-body-center-panel-study-session {
        position: absolute;
        width: 57%;
        height: 100%;
        border-right: 1px solid #ccc;   
        margin-left: 13%;
        background-color: white;
        z-index: 1;
        transition: transform 0.6s ease-out;
        transform: translateX(-200%);
        pointer-event: none;
    }

    .home-container-body-left-panel-footer p {
        color: #707070;
        font-size: 0px;
        font-family: figtree;
        margin-top: 10px;
    }

        // - CENTER PANEL - //

    .job-board-loading {
        margin-left: 40vw;
        margin-right: 38.5vw;
    }

    .home-container-body-center-panel {
        width: 93.5%;
        height: 100%;
        border-right: 1px solid #ccc;   
        position: relative;
        display: flex;
        flex-direction: column;
        z-index: 1;
    }

    .home-container-body-center-panel-header-btns-right-col-btn {
        width: 90%;
    }

    .home-container-body-center-panel-header-btns-right-col-btn p {
        font-size: 12.5px;
    }

    .home-container-body-center-panel-header-btns-right-col-options {
        position: absolute;
        top: 80%;
        left: 10%;
        width: 350px;
        height: 200px;
        border: 1px solid #ccc;
        border-radius: 5px;
        background-color: white;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        z-index: 10;

        opacity: 0;              /* hidden by default */
        visibility: hidden;
        transform: translateY(-10px);
        transition: all 0.3s ease; /* smooth fade-in/out */
    }

    .home-container-body-center-panel-header-btns-right-col-options.visible {
        transform: translateY(0);
        opacity: 1;              
        visibility: visible;
    }
    
    .home-container-body-center-panel-body-job-post {
        height: 295px;
    }

    .home-container-body-center-panel-body-job-post-details-top h3 {
        bottom: 23px;
    }

    .home-container-body-center-panel-body-job-post-details-bottom h5 {
        margin-top: 40.5px;
    }

    .home-container-body-center-panel-body-job-posts-loading-sentinel  {
        height: 5px;
    }

    /* --- RIGHT PANEL: Positioned for full overlay slide-in --- */

    .home-container-body-right-panel-body-top-header-right {
        max-height: 20px;
    }

    .home-container-body-right-panel-body-top-header-right-close-btn {
        // visibility: visible;
        // pointer-events: auto;
    }

    .home-container-body-right-panel {
        /* This panel needs to be positioned relative to the viewport/main container, */
        /* so it overlaps the Center Panel. */
        position: fixed; /* Use fixed or absolute relative to the main container */
        top: 0;
        right: 0;
        width: 60%; /* Decide on the width for the slide-in details (e.g., 60% of the screen) */
        height: 100vh;
        
        /* The crucial change: higher z-index for overlay */
        z-index: 100; /* Ensures it appears clearly over everything else */
        
        background-color: white; 
        border-left: 1px solid #ccc; 
        
        /* Initial state: off-screen (to the right) */
        transform: translateX(100%);
        transition: transform 0.3s ease-out;
        pointer-events: none; 
    }

    /* --- RIGHT PANEL: Active state (triggered when job is clicked) --- */
    .home-container-body-right-panel.active {
        transform: translateX(0); /* Slides into view */
        pointer-events: auto; 
    }

    /* --- NEW: Backdrop CSS --- */
    .home-container-backdrop {
        /* Fixed positioning to cover the whole viewport */
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        
        /* Must be visible but below the sliding panel (z-index 100) */
        z-index: 90;
        
        /* Dimming effect (semi-transparent black) */
        background-color: rgba(0, 0, 0, 0.5); 

        /* Hidden by default */
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease; /* Smooth fade-in/out */
        pointer-events: none; /* Crucial: ensures clicks pass through when hidden */
    }

    .home-container-backdrop.visible {
        opacity: 1;
        visibility: visible;
        pointer-events: auto; /* Enable closing click when visible */
    }

    .home-container-body-right-panel-body-bottom {
        flex: 1;
        // border: 1px solid purple;
        display: flex;
        position: relative;
        flex-direction: column;
        padding-bottom: 30px;
        overflow-y: auto;
    }

    .home-container-body-right-panel-footer button {
        position: absolute;
        left: 0;
        width: 96%;
        height: 65%;
        margin-left: 2%;
        border-radius: 5px;
        background-color: #2CE8A3;
        color: black;
        font-family: figtree;
        font-size: 16px;
        border: 1px solid #2CE8A3;
        // font-weight: bold;
        cursor: pointer;
    }


}

@media (min-width: 1025px) and (max-width: 1199px) {

        // - - NOTIFICATION MODAL - //

    .notificationModal {
        position: absolute;
        top: 0.8%;
        left: 0.5%;
        width: 30%;
        height: 75px;
        background-color: white;
        border: 1.25px solid #11b677;
        z-index: 1000;
        transform: translateX(-150%);
        transition: transform 0.8s ease;
    }

        // - EMAIL SUBSCRIBER - //

    .home-container-header img {
        width: 10.5%;
    }

    .home-container-header-subscription-box h5 {
        position: absolute;
        top: 0;
        left: 0;
        text-align: left;
        font-size: 12px;
        font-family: figtree;
        margin-top: 12.5px;
        margin-left: 3.25px;
        font-weight: normal;
    }

        // - CENTER PANEL - //

    .job-board-loading {
        margin-left: 24vw;
        margin-right: 20.5vw;
    }

    .home-container-body-center-panel-body-job-post {
        height: 250px;
    }

    .home-container-body-center-panel-header-btns-right-col-btn {
        width: 90%;
    }

    .home-container-body-center-panel-header-btns-right-col-btn p {
        font-size: 11.5px;
    }

    .home-container-body-center-panel-header-btns-right-col-options {
        position: absolute;
        top: 80%;
        left: 10%;
        width: 350px;
        height: 200px;
        border: 1px solid #ccc;
        border-radius: 5px;
        background-color: white;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        z-index: 10;

        opacity: 0;              /* hidden by default */
        visibility: hidden;
        transform: translateY(-10px);
        transition: all 0.3s ease; /* smooth fade-in/out */
    }

    .home-container-body-center-panel-header-btns-right-col-options.visible {
        transform: translateY(0);
        opacity: 1;              
        visibility: visible;
    }

    .home-container-body-center-panel-body-job-post {
        height: 275px;
    }

    .home-container-body-center-panel-body-job-post-icon {
        float: left;
        width: 12.35%;
        height: 100%;
        // border: 1px solid black;
        display: flex;
        justify-content: center; /* centers horizontally */
        align-items: center;
        flex-direction: column;
    }

    .home-container-body-center-panel-body-job-post-icon img {
        width: 70%;
        border-radius: 5px;
        border: 1px solid transparent;
        margin-top: 10%;
        margin-right: -17.5%;
    }

    .home-container-body-center-panel-body-job-post-icon h5 {
        padding-left: 5px;
        padding-right: 5px;
        margin-right: -17.5%;
        font-weight: normal;
        margin-top: 10px;
        font-size: 10.5px;
        // font-family: figtree;
    }

    .home-container-body-center-panel-body-job-post-details-top h2 {
        font-size: 16.75px;
    }

    .home-container-body-center-panel-body-job-post-details-top h3 {
        font-size: 13px;
        bottom: 22.5px;
    }

    .home-container-body-center-panel-body-job-post-details-middle-left {
        width: 70%;
    }

    .home-container-body-center-panel-body-job-post-details-middle-right {
        width: 30%;
    }

    .home-container-body-center-panel-body-job-posts-loading-sentinel  {
        height: 5px;
    }

    .home-container-body-right-panel-body-top-body h2 {
        font-size: 19px;
    }

    .home-container-body-right-panel-body-top-body-job-details h4 {
        font-size: 16px;
    }

    .home-container-body-right-panel-body-bottom h3 {
        font-size: 16px;
    }

    .home-container-body-right-panel-body-bottom p {
        font-size: 16px;
    }

}

/* 💻 Desktop (1200px - 1399px) */
@media (min-width: 1200px) and (max-width: 1399px) {

    .job-board-loading {
        margin-left: 24.5vw;
        margin-right: 19.5vw;
    }

    .home-container-body-center-panel-header-btns-right-col-btn {
        width: 85%;
    }

    .home-container-body-center-panel-header-btns-right-col-btn p {
        font-size: 12px;
    }

    .home-container-body-center-panel-header-btns-right-col-options {
        position: absolute;
        top: 80%;
        left: 15%;
        width: 350px;
        height: 200px;
        border: 1px solid #ccc;
        border-radius: 5px;
        background-color: white;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        z-index: 10;

        opacity: 0;              /* hidden by default */
        visibility: hidden;
        transform: translateY(-10px);
        transition: all 0.3s ease; /* smooth fade-in/out */
    }

    .home-container-body-center-panel-header-btns-right-col-options.visible {
        transform: translateY(0);
        opacity: 1;              
        visibility: visible;
    }

    .home-container-body-center-panel-body-job-post-details-top h2 {
        font-size: 16px;
    }

    .home-container-body-center-panel-body-job-post-details-top h3 {
        font-size: 13px;
    }

    .home-container-body-center-panel-body-job-post-details-middle-left {
        width: 70%;
    }

    .home-container-body-center-panel-body-job-post-details-middle-right {
        width: 30%;
    }

}


/* 🖥️ Large Desktop (1400px+)  */
@media (min-width: 1400px) {

    .job-board-loading {
        margin-left: 24.5vw;
        margin-right: 19.5vw;
    }

}


`

export default class Home extends Component {

    constructor (props) {
        super (props);
        this.state = {
            // - - - MAIN HOME COMPONENTS - - - //

            // - - STUDY SESSIONS PAGE - - //
            studySessionsPageVisible: false,

                // - SCHEDULE ZOOM MEETING VARS - //

            showScheduleModal: false,
            schedulingMeeting: false,
            interviewDate: '',
            interviewTime: '',
            candidateName: '',
            candidateEmail: '',

            // - - EMAIL SUBSCRIBE VARS - - //

            subscriberEmail: '',
            emailSubscribing: false,
            subscriberEmailInvalid: false,
            emailSubscribeClicked: false,

            // - - NOTIFICATION MODELS - - //
            showNotification: false,
            notificationMessage: '',
            notificationType: '', // "success", "error", "info"

            // - - MAIN SCREEN MODALS - - //
            
            showModal: false,
            modalType: '', // "delete", "report", "share", etc.

                // - SHARE MODAL VARS - //
            leaveANoteText: '',
            copyEmailJobDetailsClicked: false,
            copyWhatsappJobDetailsClicked: false,

                // - REPORT MODAL VARS - //
            selectedReportReasons: [], // 
            exitingReportReasonIds: [],
            reportReasons: [
            { id: 1, label: 'Unavailable', description: 'This job is no longer available', shortLabel: 'Job no longer available' },
            { id: 2, label: 'Fraudulent', description: 'This job seems suspicious / fraudulent', shortLabel: 'Job seems fraudulent' },
            { id: 3, label: 'Non-remote', description: 'This company does not hire in my country', shortLabel: 'Job not EMEA-friendly' },
            { id: 4, label: 'Other', description: 'Other', shortLabel: 'Other issue' }
            ],
            reportSubmitting: false,
            reportAdditionalDetails: '',

            // - - SEARCH BAR / FILTER TOGGLES - - //
            searchBarText: '',
            salaryRangeOptionsVisible: false,
            categoryOptionsVisible: false,

            // - - AI TEST VARS - - //
            message: '',
            response: '',

            // - - SEARCH BAR VARS - - //
            searchQuery: '',
            suggestedKeywords: [], // Now contains {keyword, jobIds, count}
            showSuggestions: false,

            // - - RENDERING JOBS VARS - - //
            allJobs: [],
            totalJobCount: 0,
            displayedJobs: [],
            selectedJobId: null,
            page: 1,
            pageSize: 20,
            loading: false,
            hasMore: true,
            filters: {
                search: '',
                salaryMin: '',
                salaryMax: '',
                company: ''
            },
            newJobLoading: false,
            loadedJobIds: new Set(), // track loaded jobs
            isRightPanelVisible: false,

            // - - SELECTED JOB VARS - - //
            selectedJob: null, 
            generatingKeywords: false,
            isFiltered: false, 
            selectedJobOptionsVisible: false,

            processingJobIds: new Set(), // ✅ Add this
     
        }

        this.observer = null;
        this.sentinelRef = React.createRef();
        this.jobDetailsRef = React.createRef();
        this.filterTimeout = null;
    }

    async componentDidMount() {
        this.loadInitialJobs();
        this.setupIntersectionObserver();
        this.setupNewJobsListener(); 

        // Fetch total count
        const totalCount = await jobService.getTotalJobCount();
        this.setState({ totalJobCount: totalCount });
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.filterTimeout) {
            clearTimeout(this.filterTimeout);
        }

        if (this.unsubscribeJobListener) {
            this.unsubscribeJobListener();
        }

        if (this.unsubscribeNewJobsListener) {
        this.unsubscribeNewJobsListener(); // Add this
  }
    }

    addJobsToState = (newJobs, prepend = false) => {
        this.setState(prevState => {
            // DON'T update displayedJobs if user has an active filter
            if (prevState.isFiltered) {
            // Only update allJobs, keep displayedJobs filtered
            const existingIds = new Set(prevState.allJobs.map(j => j.id));
            const uniqueNewJobs = newJobs.filter(job => !existingIds.has(job.id));
            
            if (uniqueNewJobs.length === 0) {
                return null;
            }

            const updatedAllJobs = prepend 
                ? [...uniqueNewJobs, ...prevState.allJobs]
                : [...prevState.allJobs, ...uniqueNewJobs];

            return {
                allJobs: updatedAllJobs,
                loadedJobIds: new Set(updatedAllJobs.map(j => j.id))
                // displayedJobs stays the same (filtered)
            };
            }

            // Normal update when not filtered
            const existingIds = new Set(prevState.allJobs.map(j => j.id));
            const uniqueNewJobs = newJobs.filter(job => !existingIds.has(job.id));
            
            if (uniqueNewJobs.length === 0) {
            return null;
            }

            const updatedAllJobs = prepend 
            ? [...uniqueNewJobs, ...prevState.allJobs]
            : [...prevState.allJobs, ...uniqueNewJobs];
            
            const updatedDisplayedJobs = prepend
            ? [...uniqueNewJobs, ...prevState.displayedJobs]
            : [...prevState.displayedJobs, ...uniqueNewJobs];

            return {
            allJobs: updatedAllJobs,
            displayedJobs: updatedDisplayedJobs,
            loadedJobIds: new Set(updatedAllJobs.map(j => j.id))
            };
        });
    }

    setupNewJobsListener = () => {
        const jobsQuery = query(
            collection(db, 'jobs'),
            orderBy('postedDate', 'desc')
        );

        let isInitialLoad = true;

        this.unsubscribeNewJobsListener = onSnapshot(jobsQuery, async (snapshot) => {
            if (isInitialLoad) {
                isInitialLoad = false;
                return;
            }

            const changes = snapshot.docChanges();
            
            for (const change of changes) {
                if (change.type === 'added') {
                    const newJob = {
                        id: change.doc.id,
                        ...change.doc.data()
                    };

                    if (this.state.loadedJobIds.has(newJob.id)) {
                        continue;
                    }

                    // console.log('New job detected:', newJob.title);

                    // ✅ Check if job needs processing
                    const needsProcessing = (!newJob.description || newJob.description.trim() === '') || newJob.jobPostParsed === false;

                    if (needsProcessing) {
                        // ✅ Show "processing" message but DON'T add job to list yet
                        this.setState({ newJobLoading: true });

                        // ✅ Process in background
                        // console.log(`Processing new job ${newJob.id} server-side...`);
                        jobService.processJobServerSide(newJob.id)
                            .catch(err => console.error('Background processing failed:', err));
                    } else {
                        // Job already processed, add it normally
                        this.addJobsToState([newJob], true);
                    }
                }
                // ✅ NEW: Handle modified jobs (when processing completes)
                else if (change.type === 'modified') {
                    const updatedJob = {
                        id: change.doc.id,
                        ...change.doc.data()
                    };

                    // console.log('Job updated:', updatedJob.title);

                    // Check if this job was being processed
                    if (this.state.newJobLoading && !this.state.loadedJobIds.has(updatedJob.id)) {
                        // ✅ First time seeing this job - it just finished processing
                        this.setState({ newJobLoading: false });
                        this.addJobsToState([updatedJob], true);
                    } else {
                        // ✅ Job already in list, just update it
                        this.setState(prevState => ({
                            allJobs: prevState.allJobs.map(job => 
                                job.id === updatedJob.id ? updatedJob : job
                            ),
                            displayedJobs: prevState.displayedJobs.map(job => 
                                job.id === updatedJob.id ? updatedJob : job
                            ),
                            selectedJob: prevState.selectedJobId === updatedJob.id 
                                ? updatedJob 
                                : prevState.selectedJob
                        }));
                    }
                }
            }
        }, (error) => {
            console.error('Error listening to new jobs:', error);
        });
    }

    setupJobListener = (jobId) => {
    // Unsubscribe from previous listener if exists
    if (this.unsubscribeJobListener) {
        this.unsubscribeJobListener();
    }

    const jobRef = doc(db, 'jobs', jobId);
    
    this.unsubscribeJobListener = onSnapshot(jobRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
        const updatedJob = {
            id: docSnapshot.id,
            ...docSnapshot.data()
        };

        // console.log('Job updated from Firestore:', updatedJob);

        // Update the job in allJobs and displayedJobs
        this.setState(prevState => ({
            allJobs: prevState.allJobs.map(job => 
            job.id === jobId ? updatedJob : job
            ),
            displayedJobs: prevState.displayedJobs.map(job => 
            job.id === jobId ? updatedJob : job
            ),
            selectedJob: prevState.selectedJobId === jobId ? updatedJob : prevState.selectedJob
        }));
        }
    }, (error) => {
        console.error('Error listening to job updates:', error);
    });
    }

    handleChange = (e) => {
        this.setState({ message: e.target.value });
    };

    sendMessage = async () => {
        const res = await fetch(
        "http://localhost:5001/workremotelyonline/us-central1/getChatResponse",
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ message: this.state.message }),
        }
        );

        // For now, just read the raw text without JSON parsing
        const text = await res.text(); 
        this.setState({ response: text });
    };

    salaryRangeMenuClick = () => {
        this.setState({
            salaryRangeOptionsVisible: !this.state.salaryRangeOptionsVisible,
            categoryOptionsVisible: false,
        });
    }

    categoryMenuClick = () => {
        this.setState({
            categoryOptionsVisible: !this.state.categoryOptionsVisible,
            salaryRangeOptionsVisible: false,
        });
    }

    setupIntersectionObserver() {
        // 1. If an observer already exists, disconnect it first to prevent memory leaks
        if (this.observer) this.observer.disconnect();

        this.observer = new IntersectionObserver(
            (entries) => {
                // entries[0] is our sentinel
                if (entries[0].isIntersecting && this.state.hasMore && !this.state.loading) {
                    // console.log("Sentinel triggered - loading more jobs");
                    this.loadMoreJobs();
                }
            },
            { 
                // 2. Specify the SCROLLABLE container as the root
                // This ensures the intersection is calculated relative to the div, not the whole screen
                root: document.querySelector('.home-container-body-center-panel-body'),
                
                // 3. Add a margin so it triggers BEFORE the user hits the absolute bottom
                // '200px' means "load more when the sentinel is 200px away from the bottom"
                rootMargin: '200px', 
                
                threshold: 0.1 
            }
        );

        // Observe the sentinel element
        if (this.sentinelRef.current) {
            this.observer.observe(this.sentinelRef.current);
        }
    }

    // Handle email subscriber email input
    handleSubscriberEmailChange = (e) => {
        this.setState({
            subscriberEmail: e.target.value
        });
    };

    // Handle email subscriber clicked
    handleEmailSubscriberClicked = async () => {
        const email = this.state.subscriberEmail.trim().toLowerCase();
        const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        // Clear previous messages
        this.setState({
            subscriberEmailInvalid: false,
            subscribeMessage: '',
            subscribeError: ''
        });

        if (!email) {
            this.setState({
                subscriberEmailInvalid: true,
                subscribeError: 'Please enter your email',
                showNotification: true,
                notificationMessage: 'Please enter your email',
                notificationType: 'error'
            });
            return;
        }

        if (!isValid) {
            this.setState({
                subscriberEmailInvalid: true,
                subscribeError: 'Please enter a valid email address',
                showNotification: true,
                notificationMessage: 'Please enter a valid email address',
                notificationType: 'error'
            });
            return;
        }

        // Show loading state
        this.setState({ emailSubscribing: true });

        // ✅ Valid email — show consent modal instead of subscribing immediately
        this.toggleModal('consent');;
    }

    confirmSubscribe = async () => {
        const email = this.state.subscriberEmail.trim().toLowerCase();
        this.closeModal();
        this.setState({ emailSubscribing: true });
        await this.pushEmailSubscriberToDatabase(email);
    }

    // Push email subscriber to database
    pushEmailSubscriberToDatabase = async (email) => {
        try {
            const result = await emailSubscriptionService.subscribe(email);

            if (result.success) {
            this.setState({
                emailSubscribing: false,
                subscribeMessage: 'Thanks for subscribing! 🎉',
                subscriberEmail: '', // Clear input
                subscriberEmailInvalid: false,
                showNotification: true,
                notificationMessage: 'Thanks for subscribing! 🎉 Expect an email from us soon.',
                notificationType: 'success'
            });

            // Clear success message after 5 seconds
            setTimeout(() => {
                this.setState({ subscribeMessage: '' , showNotification: false  });
            }, 5000);
           
            } else {
                this.setState({
                    emailSubscribing: false,
                    subscribeError: result.error || 'Failed to subscribe',
                    subscriberEmailInvalid: true,
                    showNotification: true,
                    notificationMessage: result.error || 'Failed to subscribe',
                    notificationType: 'error'
                });
            }
        } catch (error) {
            // console.error('Error subscribing:', error);
            this.setState({
                emailSubscribing: false,
                subscribeError: error || 'Something went wrong. Please try again.',
                subscriberEmailInvalid: true,
                showNotification: true,
                notificationMessage: error || 'Something went wrong. Please try again.',
                notificationType: 'error'
            });
        }
    }

    // Initial job load
    async loadInitialJobs() {
        this.setState({ loading: true });
        
        try {
            const { jobs, lastDoc, hasMore } = await jobService.getJobs(this.state.pageSize);
            
            // Track all initially loaded job IDs
            const jobIds = new Set(jobs.map(job => job.id));
            
            this.setState({
            allJobs: jobs,
            displayedJobs: jobs,
            lastDoc,
            hasMore,
            loading: false,
            loadedJobIds: jobIds // Add this
            });
        } catch (error) {
            console.error('Error loading jobs:', error);
            this.setState({ loading: false });
        }
    }

    // Load more jobs (infinite scroll)
    async loadMoreJobs() {
        if (this.state.loading) return;

        this.setState({ loading: true });

        try {
            const { jobs, lastDoc, hasMore } = await jobService.getNextJobs(
            this.state.pageSize, 
            this.state.lastDoc
            );

            // Use helper method
            this.addJobsToState(jobs, false); // false = append to end

            this.setState({
            lastDoc,
            hasMore,
            loading: false
            });
        } catch (error) {
            console.error('Error loading more jobs:', error);
            this.setState({ loading: false });
        }
    }

    // Format posted date
    formatPostedDate = (timestamp) => {
        const now = new Date();
        
        // Convert Firestore Timestamp to JavaScript Date
        let posted;
        if (timestamp?.toDate) {
            // It's a Firestore Timestamp
            posted = timestamp.toDate();
        } else if (timestamp instanceof Date) {
            // It's already a Date object
            posted = timestamp;
        } else {
            // It's a string or something else
            posted = new Date(timestamp);
        }
        
        const diffTime = Math.abs(now - posted);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        
        if (diffDays === 0) return 'Posted today';
        if (diffDays === 1) return 'Posted 1 day ago';
        if (diffDays < 7) return `Posted ${diffDays} days ago`;
        if (diffDays < 30) return `Posted ${Math.floor(diffDays / 7)} week(s) ago`;
        return `Posted ${Math.floor(diffDays / 30)} month(s) ago`;
    }

    // Handle search input:
    handleSearchInput = async (e) => {
        const searchQuery = e.target.value;
        this.setState({ searchQuery });

        if (searchQuery.trim().length > 0) {
            const suggestions = await keywordService.getSuggestedKeywords(searchQuery, 10);
            this.setState({ 
            suggestedKeywords: suggestions,
            showSuggestions: true 
            });
        } else {
            // Clear search and reset
            this.setState({ 
                suggestedKeywords: [],
                showSuggestions: false,
                displayedJobs: this.state.allJobs,
                isFiltered: false // Clear filter flag
            });

            // ✅ Scroll to top when clearing search
            // ✅ Use the ref instead
            const firstJobCard = document.querySelector('.home-container-body-center-panel-body-job-post');
                if (firstJobCard) {
                    firstJobCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
        }
    }

    // Handle selecting a keyword:
    handleSelectKeyword = async (keywordObj) => {
        this.setState({ 
            searchQuery: keywordObj.keyword,
            showSuggestions: false,
            isFiltered: true,
            loading: true // Show loading state
        });
        
        try {
            // First check if we already have these jobs loaded
            const loadedJobIds = new Set(this.state.allJobs.map(j => j.id));
            const alreadyLoadedJobs = this.state.allJobs.filter(job => 
            keywordObj.jobIds.includes(job.id)
            );
            
            // Find job IDs we need to fetch from Firestore
            const jobIdsToFetch = keywordObj.jobIds.filter(id => !loadedJobIds.has(id));
            
            let allMatchingJobs = [...alreadyLoadedJobs];
            
            // Fetch missing jobs from Firestore
            if (jobIdsToFetch.length > 0) {
                const fetchedJobs = await jobService.getJobsByIds(jobIdsToFetch);
                
                // ✅ Just add jobs immediately, no processing
                allMatchingJobs = [...alreadyLoadedJobs, ...fetchedJobs];
                
                // Add fetched jobs to allJobs for future reference
                this.setState(prevState => ({
                    allJobs: [...prevState.allJobs, ...fetchedJobs],
                    loadedJobIds: new Set([...prevState.loadedJobIds, ...fetchedJobs.map(j => j.id)])
                }));

                // ✅ Trigger background processing for any unprocessed jobs
                fetchedJobs.forEach(job => {
                    if ((!job.description || job.description.trim() === '') || job.jobPostParsed === false) {
                        jobService.processJobServerSide(job.id).catch(err => 
                            console.error(`Background processing failed for ${job.id}:`, err)
                        );
                    }
                });
            }
            
            this.setState({ 
                displayedJobs: allMatchingJobs,
                loading: false
            }, () => {
                // ✅ Scroll happens AFTER jobs render
                    // ✅ Use the ref instead
               const firstJobCard = document.querySelector('.home-container-body-center-panel-body-job-post');
                if (firstJobCard) {
                    firstJobCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
            
            // console.log(`Showing ${allMatchingJobs.length} jobs for keyword: ${keywordObj.keyword}`);

            // ✅ Scroll to top of job list
            // const jobListContainer = document.querySelector('.home-container-body-center-panel-body');
            // if (jobListContainer) {
            //     jobListContainer.scrollTop = 0;
            // }
            
        } catch (error) {
            console.error('Error filtering by keyword:', error);
            this.setState({ loading: false });
        }
    }

    // Handle filter changes
    handleFilterChange = (filterType, value) => {
        this.setState(
        prevState => ({
            filters: {
            ...prevState.filters,
            [filterType]: value
            }
        }),
        () => {
            // Debounce filtering for better performance
            clearTimeout(this.filterTimeout);
            this.filterTimeout = setTimeout(this.applyFilters, 300);
        }
        );
    }

    // Apply filters to job list
    applyFilters = () => {
        const { allJobs, filters } = this.state;
        
        let filtered = allJobs.filter(job => {
        // Search filter (title, company)
        const matchesSearch = !filters.search || 
            job.title.toLowerCase().includes(filters.search.toLowerCase()) ||
            job.company.toLowerCase().includes(filters.search.toLowerCase());
        
        // Company filter
        const matchesCompany = !filters.company || 
            job.company.toLowerCase().includes(filters.company.toLowerCase());
        
        // Salary filters (basic implementation - you may need to parse salary strings)
        let matchesSalary = true;
        if (filters.salaryMin || filters.salaryMax) {
            // Extract min salary from string like "$15 - 25/hr"
            const salaryMatch = job.salary.match(/\$(\d+)/);
            if (salaryMatch) {
            const jobSalary = parseInt(salaryMatch[1]);
            if (filters.salaryMin && jobSalary < parseInt(filters.salaryMin)) {
                matchesSalary = false;
            }
            if (filters.salaryMax && jobSalary > parseInt(filters.salaryMax)) {
                matchesSalary = false;
            }
            }
        }
        
        return matchesSearch && matchesCompany && matchesSalary;
        });

        this.setState({ displayedJobs: filtered });
    }

    // Handle job selection
    handleJobClick = (jobId) => {
        const job = this.state.displayedJobs.find(j => j.id === jobId);
        this.setState({ 
            selectedJobId: jobId,
            selectedJob: job,
            isRightPanelVisible: true,
            selectedJobOptionsVisible: false
        }, () => {
            // ✅ Scroll to top after state updates
            if (this.jobDetailsRef.current) {
                this.jobDetailsRef.current.scrollTop = 0;
            }
        });
    
        // Start listening to this job's updates
        this.setupJobListener(jobId);

        // this.cleanupExcessKeywords()
        // console.log('Selected jobID:', jobId);

        // Auto-generate keywords if missing AND fullJobPost exists
        if ((!job.searchKeywords || job.searchKeywords.length === 0) && 
            job.fullJobPost && 
            job.fullJobPost.trim() !== '') {
            
            // console.log(`Keywords missing for job: ${job.title}. Generating automatically...`);
            
            // Run keyword generation in the background
            this.generateKeywordsForJob(jobId);
        }
    }

    // Format the full job post
    formatJobPost = (fullJobPost) => {
        if (!fullJobPost) return '<p>No job description available.</p>';

        // Split by the header marker
        const sections = fullJobPost.split('###HEADER###').filter(s => s.trim());
        
        let html = '';
        
        sections.forEach(section => {
            const lines = section.trim().split('\n').filter(l => l.trim());
            if (lines.length === 0) return;
            
            const header = lines[0].trim();
            const content = lines.slice(1).join(' ').trim(); // Join all lines into one paragraph
            
            if (!header) return;
            
            // Add the header
            html += `<h4>${header}</h4>`;
            
            // Add content as paragraphs (split by double line breaks if present)
            const paragraphs = content.split(/\n\n+/).filter(p => p.trim());
            
            paragraphs.forEach(para => {
            const trimmed = para.trim();
            if (trimmed) {
                html += `<p>${trimmed}</p>`;
            }
            });
        });
        
        return html;
    };

    // Simple keyword search with match counting
    searchJobsByKeywords = (searchTerm) => {
        const searchWords = searchTerm.toLowerCase().split(' ').filter(w => w.length > 2);
        
        const resultsWithScores = this.state.allJobs.map(job => {
            let matchCount = 0;
            
            // Check keywords array
            if (job.searchKeywords && job.searchKeywords.length > 0) {
            searchWords.forEach(searchWord => {
                job.searchKeywords.forEach(keyword => {
                if (keyword.toLowerCase().includes(searchWord) || 
                    searchWord.includes(keyword.toLowerCase())) {
                    matchCount++;
                }
                });
            });
            }
            
            return { job, matchCount };
        })
        .filter(result => result.matchCount > 0) // Only jobs with matches
        .sort((a, b) => b.matchCount - a.matchCount); // Sort by most matches first
        
        const filteredJobs = resultsWithScores.map(r => r.job);
        
        // console.log('Search results:', resultsWithScores.map(r => ({
        //     title: r.job.title,
        //     matches: r.matchCount
        // })));
        
        this.setState({ displayedJobs: filteredJobs });
    }

    // Generates keywords for existing job posts
    generateKeywordsForJob = async (jobId) => {
        const job = this.state.allJobs.find(j => j.id === jobId);
        
        if (!job) {
            // console.error('Job not found');
            return;
        }

        if (job.searchKeywords && job.searchKeywords.length > 0) {
            // console.log('Keywords already exist, skipping generation');
            return;
        }

        if (!job.fullJobPost || job.fullJobPost.trim() === '') {
            // console.warn('This job has no fullJobPost to generate keywords from.');
            return;
        }

        // console.log('🔄 Starting keyword generation for:', job.title);
        this.setState({ generatingKeywords: true });

        try {
            // console.log('📤 Calling parseJobPost...');
            const structuredData = await jobPostParser.parseJobPost(job.fullJobPost);
            
            // console.log('📥 Received structuredData:', structuredData);
            // console.log('🔑 Keywords:', structuredData?.searchKeywords);
            
            if (structuredData && structuredData.searchKeywords) {
            // console.log(`💾 Saving ${structuredData.searchKeywords.length} keywords to Firestore...`);
            
            // Update Firestore with keywords
            await jobService.updateJobKeywords(jobId, structuredData.searchKeywords);
            
            // console.log('✅ Firestore update complete');
            
            // Update local state
            this.setState(prevState => ({
                allJobs: prevState.allJobs.map(j => 
                j.id === jobId 
                    ? { ...j, searchKeywords: structuredData.searchKeywords }
                    : j
                ),
                displayedJobs: prevState.displayedJobs.map(j => 
                j.id === jobId 
                    ? { ...j, searchKeywords: structuredData.searchKeywords }
                    : j
                ),
                selectedJob: prevState.selectedJobId === jobId 
                ? { ...prevState.selectedJob, searchKeywords: structuredData.searchKeywords }
                : prevState.selectedJob,
                generatingKeywords: false
            }));
            
            // console.log(`✅ Successfully generated ${structuredData.searchKeywords.length} keywords for ${job.title}`);
            
            // NEW: Update the keywords collection
            // console.log('🔄 Updating keywords collection...');
            await this.updateKeywordsCollection();
            // console.log('✅ Keywords collection updated');
            
            } else {
            // console.error('❌ No keywords in structuredData');
            this.setState({ generatingKeywords: false });
            }
        } catch (error) {
            // console.error('❌ Error generating keywords:', error);
            this.setState({ generatingKeywords: false });
        }
    }

    // Add this new method:
    updateKeywordsCollection = async () => {
        try {
            const result = await keywordService.aggregateKeywords();
            
            if (result.success) {
            // console.log(`✅ Aggregated ${result.totalKeywords} unique keywords`);
            
            // Refresh cached keywords
            keywordService.clearCache();
            }
        } catch (error) {
            console.error('Error updating keywords collection:', error);
            // Don't throw - this is not critical, job keywords are already saved
        }
    }

    // Add this temporary admin button
    cleanupExcessKeywords = async () => {
        const jobsToClean = this.state.allJobs.filter(job => 
            job.searchKeywords && job.searchKeywords.length > 10
        );

        // console.log(`Found ${jobsToClean.length} jobs with too many keywords`);

        for (const job of jobsToClean) {
            // Delete the searchKeywords field
            await jobService.updateJobKeywords(job.id, []);
            // console.log(`Cleared keywords for: ${job.title}`);
        }

        // alert('Cleanup complete. Click each job to regenerate with fewer keywords.');
    }

    // Selected job options clicked
    selectedJobOptionsClicked = () => {
        this.setState(prevState => ({
            selectedJobOptionsVisible: !prevState.selectedJobOptionsVisible
        }));
    }

    // Toggle STUDY SESSIONS
    handleToggleStudySessions = () => {
        this.setState(prevState => ({
            studySessionsPageVisible: !prevState.studySessionsPageVisible
        }));
    }

    // Toggle modal  / 
    toggleModal = (modalType) => {
        // Step 1: open modal + set loading state
        this.setState({
            showModal: true,
            modalType: "loading"
        });

        // Step 2: after a short delay, show the real modal type
        setTimeout(() => {
            this.setState({
            modalType: modalType
            });
        }, 500); // 1.5 seconds; adjust as needed
    };

    // Close modal
    closeModal = () => {
        this.setState({
            showModal: false,
            modalType: null,
            copyEmailJobDetailsClicked: false,
            copyWhatsappJobDetailsClicked: false,
            leaveANoteText: '',
            selectedReportReasons: [],
            exitingReportReasonIds: [],
            reportAdditionalDetails: '',
            emailSubscribing: false
        });
    };

    // Handles 'Leave a note' text box in 'Share' modal
    handleLeaveNoteChangeShareModal = (event) => {
        this.setState({ leaveANoteText: event.target.value });
    };

    // Copies (Email) job details + note in 'Share' modal 
   copyEmailContent = () => {
    const { leaveANoteText, selectedJob } = this.state;

    const plainText = 
        leaveANoteText + "\n\n" +
        `Role: ${selectedJob.title}\n` +
        `Company: ${selectedJob.company}\n` +
        `Base compensation: ${selectedJob.salary}\n` +
        (selectedJob.jobAppURL ? `Apply: ${selectedJob.jobAppURL}\n` : "") +
        "\n--------------------\n\n" +
        selectedJob.fullJobPost;

    // ✅ Check if browser supports ClipboardItem (desktop browsers)
    if (navigator.clipboard && window.ClipboardItem) {
        const noteHtml = leaveANoteText.split("\n").map(line => line || "<br>").join("<br>");
        const jobHtml = this.formatJobPost(selectedJob.fullJobPost);
        const jobMetaHtml = `
            <p><strong>Role:</strong> ${selectedJob.title || "N/A"}</p>
            <p><strong>Company:</strong> ${selectedJob.company || "N/A"}</p>
            <p><strong>Base compensation:</strong> ${selectedJob.salary || "Not listed"}</p>
        `;
        const applyHtml = selectedJob.jobAppURL
            ? `<p><a href="${selectedJob.jobAppURL}" target="_blank">Apply</a></p>`
            : "";
        const finalHtml = `
            <div>
                <p>${noteHtml}</p>
                <hr/>
                ${jobMetaHtml}
                <hr/>
                ${applyHtml}
                ${jobHtml}
            </div>
        `;

        navigator.clipboard.write([
            new ClipboardItem({
                "text/html": new Blob([finalHtml], { type: "text/html" }),
                "text/plain": new Blob([plainText], { type: "text/plain" })
            })
        ])
        .then(() => {
            this.setState({
                copyEmailJobDetailsClicked: true,
                copyWhatsappJobDetailsClicked: false
            });
        })
        .catch(err => {
            console.error("ClipboardItem failed, using text fallback:", err);
            this.fallbackCopyText(plainText);
        });
    } else {
        // Safari mobile fallback — just copy plain text
        this.fallbackCopyText(plainText);
        this.setState({
            copyEmailJobDetailsClicked: true,
            copyWhatsappJobDetailsClicked: false
        });
    }
};

    // Copies (WhatsApp) job details + note in 'Share' modal
    copyWhatsAppContent = () => {
    const { leaveANoteText, selectedJob } = this.state;

    const noteText = leaveANoteText || "";
    const jobMetaText =
`*Role:* ${selectedJob.title || "N/A"}
*Company:* ${selectedJob.company || "N/A"}
*Base compensation:*
${selectedJob.salary || "Not listed"}`;

    const applyText = selectedJob.jobAppURL
        ? `Apply: ${selectedJob.jobAppURL}`
        : "";

    let raw = this.formatJobPost(selectedJob.fullJobPost) || "";
    raw = raw
        .replace(/<\/h4>/gi, "\n")
        .replace(/<h4>/gi, "###HEADER###")
        .replace(/<\/p>/gi, "\n")
        .replace(/<p>/gi, "")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<[^>]+>/g, "")
        .trim();

    raw = raw
        .split("\n")
        .map(line => {
            if (line.startsWith("###HEADER###")) {
                const header = line.replace("###HEADER###", "").trim();
                return `\n*${header}*\n`;
            }
            return line;
        })
        .join("\n");

    raw = raw.replace(/\n{3,}/g, "\n\n");

    const finalText =
`${noteText}

--------------------

${jobMetaText}

--------------------

${applyText}

${raw}
`;

    // ✅ Safari-compatible clipboard write
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(finalText)
            .then(() => {
                this.setState({
                    copyEmailJobDetailsClicked: false,
                    copyWhatsappJobDetailsClicked: true
                });
            })
            .catch(err => {
                console.error("Clipboard API failed, trying fallback:", err);
                this.fallbackCopyText(finalText);
            });
    } else {
        // Fallback for older browsers/Safari
        this.fallbackCopyText(finalText);
    }
};

fallbackCopyText = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.top = "-9999px";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        document.execCommand('copy');
        this.setState({
            copyEmailJobDetailsClicked: false,
            copyWhatsappJobDetailsClicked: true
        });
    } catch (err) {
        console.error('Fallback copy failed:', err);
        alert('Copy failed. Please try again.');
    }

    document.body.removeChild(textArea);
}
    // Show interview scheduler
    handleScheduleInterview = () => {
        this.setState({ showScheduleModal: true });
    }

    // Add this method to create the meeting:
    createInterviewMeeting = async () => {
        const { selectedJob, interviewDate, interviewTime, candidateName } = this.state;

        if (!interviewDate || !interviewTime) {
            alert('Please select date and time');
            return;
        }

        if (!candidateName || candidateName.trim() === '') {
            alert('Please enter candidate name');
            return;
        }

        this.setState({ schedulingMeeting: true });

        try {
            // console.log('📅 Scheduling interview...');
            const startTime = new Date(`${interviewDate}T${interviewTime}:00`).toISOString();
            // console.log('Start time:', startTime);

            const result = await zoomService.createMeeting({
            topic: `Topic`,
            startTime: startTime,
            duration: 30,
            agenda: `Interview discussion`,
            candidateName: candidateName
            });

            // console.log('Result:', result);

            if (result.success) {
            alert(`Interview scheduled!\n\nMeeting Link: ${result.meeting.joinUrl}\nPassword: ${result.meeting.password}`);
            
            this.setState({
                showModal: false,
                modalType: '',
                schedulingMeeting: false,
                interviewDate: '',
                interviewTime: '',
                candidateName: '',
                candidateEmail: ''
            });
            } else {
            console.error('Failed result:', result);
            alert(`Failed to schedule: ${result.error}\n\nDetails: ${JSON.stringify(result.details || {})}`);
            this.setState({ schedulingMeeting: false });
            }
        } catch (error) {
            console.error('Catch error:', error);
            alert(`Error scheduling interview: ${error.message}`);
            this.setState({ schedulingMeeting: false });
        }
    }

    // Report job option clicked
    reportJobOptionClicked = (reasonId) => {
        this.setState(prevState => {
            const isSelected = prevState.selectedReportReasons.includes(reasonId);

            if (isSelected) {
            // mark as exiting ONLY
            return {
                exitingReportReasonIds: [
                ...prevState.exitingReportReasonIds,
                reasonId
                ]
            };
            }

            // add immediately (same as before)
            return {
            selectedReportReasons: [...prevState.selectedReportReasons, reasonId]
            };
        });
    };

    // Report job exit animation ended
    handleExitAnimationEnd = (reasonId) => {
        this.setState(prevState => ({
            selectedReportReasons: prevState.selectedReportReasons.filter(
            id => id !== reasonId
            ),
            exitingReportReasonIds: prevState.exitingReportReasonIds.filter(
            id => id !== reasonId
            )
        }));
    };

    // Function to hide the right panel
    handleCloseRightPanel = () => {
        this.setState({
            isRightPanelVisible: false,
            // Optional: clear selection when closing
            // selectedJobId: null, 
            // selectedJob: null 
        });
    };

    // Apply to job btn clicked
    applyBtnClicked = () => {
        const { selectedJob } = this.state;

        if (selectedJob && selectedJob.jobAppURL) {
            window.open(selectedJob.jobAppURL, '_blank');
        } else {
            alert('Application URL not available for this job.');
        }
    }

    // Visit website btn clicked
    visitWebsiteBtnClicked = () => {
        const { selectedJob } = this.state;

        if (selectedJob && selectedJob.companyURL) {
            window.open(selectedJob.companyURL, '_blank');
        } else {
            alert('Company website URL not available for this job.');
        }
    }

    // Close notification modal
    closeNotificationModal = () => {
        this.setState({ showNotification: false, notificationMessage: '', notificationType: ''});
    }

    // Submit report to Firestore
    submitReport = async () => {
        const { selectedJob, selectedReportReasons, reportAdditionalDetails, reportReasons } = this.state;

        if (selectedReportReasons.length === 0) return;

        this.setState({ reportSubmitting: true });

        try {
            await addDoc(collection(db, 'reports'), {
                jobId: selectedJob.id,
                jobTitle: selectedJob.title,
                company: selectedJob.company,
                reasons: selectedReportReasons.map(id => {
                    const reason = reportReasons.find(r => r.id === id);
                    return { id, label: reason?.label, shortLabel: reason?.shortLabel };
                }),
                additionalDetails: reportAdditionalDetails || '',
                reportedAt: serverTimestamp()
            });

            this.setState({
                reportSubmitting: false,
                showNotification: true,
                notificationMessage: 'Report submitted. Thank you! 🙏',
                notificationType: 'success'
            });

            this.closeModal();

        } catch (error) {
            console.error('Error submitting report:', error);
            this.setState({
                reportSubmitting: false,
                showNotification: true,
                notificationMessage: 'Failed to submit report. Please try again.',
                notificationType: 'error'
            });
        }
    }


    render () {
        const { totalJobCount, isFiltered, displayedJobs, selectedJobId, loading, filters, selectedJob, newJobLoading, searchQuery, suggestedKeywords, showSuggestions, showScheduleModal, schedulingMeeting, interviewDate, interviewTime, candidateName, isRightPanelVisible } = this.state;
        const centerPanelClass = "home-container-body-center-panel"; 
        const rightPanelClass = isRightPanelVisible ? "home-container-body-right-panel active" : "home-container-body-right-panel";
        // Backdrop class based on visibility state
        const backdropClass = isRightPanelVisible 
            ? "home-container-backdrop visible" 
            : "home-container-backdrop";


        return (
            <Styles>
                <div className="home-container">

                    {/* ✅ TEMPORARY CLEANUP BUTTON - Remove after running once
                    <button 
                    onClick={async () => {
                        if (!window.confirm('Run keyword cleanup? This will take a while.')) return;
                        
                        console.log('🧹 Starting cleanup...');
                        const result = await keywordService.cleanupOrphanedKeywords();
                        
                        if (result.success) {
                        alert(`✅ Done! Deleted ${result.deletedCount} keywords, updated ${result.updatedCount} keywords`);
                        } else {
                        alert(`❌ Failed: ${result.error}`);
                        }
                    }}
                    style={{
                        position: 'fixed',
                        top: '10px',
                        right: '10px',
                        zIndex: 9999,
                        padding: '10px 20px',
                        backgroundColor: '#ff6b6b',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                    >
                    🧹 Clean Up Keywords (Run Once)
                    </button> */}

                    <CookieBanner />

                    <div className='big-screen-links'>
                        <p onClick={() => window.open('https://gray-helicona-f30.notion.site/Terms-of-Service-2da9fd4feb7480779c5ad2c07ea8382e', '_blank')}>Terms of Service</p>
                        <p onClick={() => window.open('https://www.notion.so/Privacy-Policy-2fb9fd4feb7480b6aeaffec54c44fb3d', '_blank')}>Privacy Policy</p>
                    </div>

                    <div className={`notificationModal ${this.state.showNotification ? 'display' : ''}`}>
                        <img onClick={this.closeNotificationModal} src='/assets/close-icon-color.png'/>
                        <p>{this.state.notificationMessage}</p>
                    </div> 

                    <Modal isOpen={this.state.showModal} onClose={this.closeModal}>

                        {this.state.modalType === "loading" && (
                            <div className="modal-loading-container">
                                <div className="modal-loading-container-spinner"></div>
                            </div>
                        )}

                        {this.state.modalType === "delete" && (
                            <div>
                            <h2>Delete Item</h2>
                            <p>Are you sure?</p>
                            </div>
                        )}

                        {this.state.modalType === "report" && (
                            <div className='modal-share-ui-container'>
                                <div className='modal-share-ui-container-header'>
                                    <div className='modal-share-ui-container-header-left'>
                                        <h1>Report</h1>
                                        <h3>Report an issue with this job posting</h3>
                                    </div>
                                    <div className='modal-share-ui-container-header-right'>
                                        <img onClick={this.closeModal} src='/assets/close-icon.png'/>
                                    </div>
                                </div>
                                <div className='modal-report-ui-container-body'>
                                    <div className='modal-report-ui-container-body-left'>
                                        <div className='modal-report-ui-container-body-left-header'>
                                            <h4><span>Company:</span> {selectedJob?.company}</h4>
                                            <h4><span>Base salary:</span> {selectedJob?.salary !== '' ? selectedJob?.salary : 'Undisclosed'}</h4>
                                            <h4><span>Position:</span></h4>
                                            <h3>{selectedJob?.title}</h3>
                                        </div>
                                        <div className='modal-report-ui-container-body-left-body'>
                                            <div className='modal-report-ui-container-body-left-body-report-cell'>
                                                <div className='modal-report-ui-container-body-left-body-report-cell-checkbox'>
                                                    <div onClick={() => this.reportJobOptionClicked(1)} className={`modal-report-ui-container-body-left-body-report-cell-checkbox-container ${this.state.selectedReportReasons.includes(1) ? 'selected' : ''}`}>
                                                        {this.state.selectedReportReasons.includes(1) && 
                                                            <img src='/assets/checkmark.png'/>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='modal-report-ui-container-body-left-body-report-cell-description'>
                                                    <p>This job is no longer available</p>
                                                </div>
                                            </div>
                                            <div className='modal-report-ui-container-body-left-body-report-cell'>
                                                <div className='modal-report-ui-container-body-left-body-report-cell-checkbox'>
                                                    <div onClick={() => this.reportJobOptionClicked(2)} className={`modal-report-ui-container-body-left-body-report-cell-checkbox-container ${this.state.selectedReportReasons.includes(2) ? 'selected' : ''}`}>
                                                        {this.state.selectedReportReasons.includes(2) && 
                                                            <img src='/assets/checkmark.png'/>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='modal-report-ui-container-body-left-body-report-cell-description'>
                                                    <p>This job seems suspicious / fraudulent</p>
                                                </div>
                                            </div>
                                            <div className='modal-report-ui-container-body-left-body-report-cell'>
                                                <div className='modal-report-ui-container-body-left-body-report-cell-checkbox'>
                                                    <div onClick={() => this.reportJobOptionClicked(3)} className={`modal-report-ui-container-body-left-body-report-cell-checkbox-container ${this.state.selectedReportReasons.includes(3) ? 'selected' : ''}`}>
                                                        {this.state.selectedReportReasons.includes(3) && 
                                                            <img src='/assets/checkmark.png'/>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='modal-report-ui-container-body-left-body-report-cell-description'>
                                                    <p>This job is not EMEA-friendly</p>
                                                </div>
                                            </div>
                                            <div className='modal-report-ui-container-body-left-body-report-cell'>
                                                <div className='modal-report-ui-container-body-left-body-report-cell-checkbox'>
                                                    <div onClick={() => this.reportJobOptionClicked(4)} className={`modal-report-ui-container-body-left-body-report-cell-checkbox-container ${this.state.selectedReportReasons.includes(4) ? 'selected' : ''}`}>
                                                        {this.state.selectedReportReasons.includes(4) && 
                                                            <img src='/assets/checkmark.png'/>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='modal-report-ui-container-body-left-body-report-cell-description'>
                                                    <p>Other (please specify below):</p>
                                                </div>
                                            </div>
                                            <div className='modal-report-ui-container-body-left-body-report-cell-textarea'>
                                                <div className={`modal-report-ui-container-body-left-body-report-cell-textarea-counter-container ${(this.state.selectedReportReasons.includes(4) || this.state.selectedReportReasons.includes(2)) && this.state.reportAdditionalDetails.length < 100 ? 'visible' : ''}`}>
                                                    <span className={`modal-report-ui-container-body-left-body-report-cell-textarea-counter ${this.state.reportAdditionalDetails.length >= 100 ? 'over-limit' : ''}`}>{this.state.reportAdditionalDetails.length}/100</span>
                                                </div>
                                                <textarea
                                                placeholder="Include any additional details"
                                                value={this.state.reportAdditionalDetails}
                                                onChange={(e) => this.setState({ reportAdditionalDetails: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='modal-report-ui-container-body-right'>
                                        <div className='modal-report-ui-container-body-right-upper'>
                                            <div className='modal-report-ui-container-body-right-upper-header'>
                                                <div className='modal-report-ui-container-body-right-upper-header-left'>
                                                    <h4>REPORT DETAILS:</h4>
                                                </div>
                                                <div className='modal-report-ui-container-body-right-upper-header-right'>
                                                    {this.state.selectedReportReasons.map((reasonId) => {
                                                        const reason = this.state.reportReasons.find(r => r.id === reasonId);
                                                        const isExiting = this.state.exitingReportReasonIds.includes(reasonId);

                                                        return (
                                                            <div 
                                                            key={reasonId}
                                                            className={`modal-report-reason-item-container ${isExiting ? "exit" : "enter"}`}
                                                            onAnimationEnd={() =>
                                                                isExiting && this.handleExitAnimationEnd(reasonId)
                                                            }
                                                            >
                                                                <div
                                                                className={`modal-report-reason-item ${this.state.selectedReportReasons.length <= 2 ? "few" : ""}`}
                                                                >
                                                                    {reason.shortLabel}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                            <div className='modal-report-ui-container-body-right-upper-body'>
                                                 <div className='modal-report-ui-container-body-right-upper-body-top'>
                                                    <h4>Additional details:</h4>
                                                    <div className={`modal-report-ui-container-body-right-upper-body-top-label ${(this.state.selectedReportReasons.includes(4) || this.state.selectedReportReasons.includes(2)) && this.state.reportAdditionalDetails.length < 100 ? 'visible' : ''}`}>
                                                        {this.state.reportAdditionalDetails.length === 0 ? "REQUIRED" : `${this.state.reportAdditionalDetails.length} / 100`}
                                                    </div>
                                                 </div>
                                                 <div className='modal-report-ui-container-body-right-upper-body-bottom'>
                                                    <p style={{ whiteSpace: 'pre-wrap'}}>{this.state.reportAdditionalDetails}</p>
                                                 </div>
                                            </div>
                                        </div>
                                        <div className='modal-report-ui-container-body-right-lower'>
                                            <div onClick={this.submitReport} className={`modal-report-ui-container-body-right-lower-btn ${
                                                    ((this.state.selectedReportReasons.includes(4) || this.state.selectedReportReasons.includes(2)) 
                                                    && this.state.reportAdditionalDetails.length < 100) 
                                                    || this.state.selectedReportReasons.length === 0
                                                    || this.state.reportSubmitting
                                                    ? 'disabled' : ''
                                                }`}>
                                                <>{this.state.reportSubmitting ? 'Submitting...' : 'Submit report'}</>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {this.state.modalType === "share" && (
                            <div className='modal-share-ui-container'>
                                <div className='modal-share-ui-container-header'>
                                    <div className='modal-share-ui-container-header-left'>
                                        <h1>Share</h1>
                                        <h3>Let someone in your network know about this job</h3>
                                    </div>
                                    <div className='modal-share-ui-container-header-right'>
                                        <img onClick={this.closeModal} src='/assets/close-icon.png'/>
                                    </div>
                                </div>
                                <div className='modal-share-ui-container-body'>
                                    <div className='modal-share-ui-container-body-left'>
                                        <div className='modal-share-ui-container-body-left-header'>
                                            <h4><span>Company:</span> {selectedJob?.company}</h4>
                                            <h4><span>Base salary:</span> {selectedJob?.salary !== '' ? selectedJob?.salary : 'Undisclosed'}</h4>
                                            <h4><span>Position:</span></h4>
                                            <h3>{selectedJob?.title}</h3>
                                        </div>
                                        <div className='modal-share-ui-container-body-left-body'>
                                            <p className="leave-note-preview-text">{this.state.leaveANoteText}</p>
                                            <h3><u>Description:</u></h3>
                                            {selectedJob?.fullJobPost ? (
                                                <div dangerouslySetInnerHTML={{ __html: this.formatJobPost(selectedJob.fullJobPost) }} />
                                            ) : (
                                                <p>No job description available.</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className='modal-share-ui-container-body-right'>
                                        <div className='modal-share-ui-container-body-right-upper'>
                                            <h4><span>Leave a note (optional):</span></h4>
                                            <textarea
                                            placeholder="I think you'd be a great fit for this!"
                                            value={this.state.leaveANoteText}
                                            onChange={this.handleLeaveNoteChangeShareModal}
                                            />
                                        </div>
                                        <div className='modal-share-ui-container-body-right-lower'>
                                            <div className='modal-share-ui-container-body-right-lower-buttons-container'>
                                                 <div
                                                 className={`modal-share-ui-container-body-right-lower-buttons-container-btn ${this.state.copyEmailJobDetailsClicked ? 'selected' : ''}`}
                                                onClick={this.copyEmailContent}
                                                >
                                                    <div className='modal-share-ui-container-body-right-lower-buttons-container-btn-icon'>
                                                        <img src={this.state.copyEmailJobDetailsClicked ? '/assets/check-icon.png': `/assets/email-icon.png`}/>
                                                    </div>
                                                    <div className='modal-share-ui-container-body-right-lower-buttons-container-btn-text'>
                                                         <p>{this.state.copyEmailJobDetailsClicked ? 'Copied successfully' : 'Copy Job Details (best for email)'}</p></div>
                                                </div>
                                                 <div
                                                 className={`modal-share-ui-container-body-right-lower-buttons-container-btn ${this.state.copyWhatsappJobDetailsClicked ? 'selected' : ''}`}
                                                onClick={this.copyWhatsAppContent}
                                                >
                                                    <div className='modal-share-ui-container-body-right-lower-buttons-container-btn-icon'>
                                                        <img src={this.state.copyWhatsappJobDetailsClicked ? '/assets/check-icon.png': `/assets/whatsapp-icon.png`}/>
                                                    </div>
                                                    <div className='modal-share-ui-container-body-right-lower-buttons-container-btn-text'>
                                                         <p>{this.state.copyWhatsappJobDetailsClicked ? 'Copied successfully' : 'Copy Job Details (best for WhatsApp)'}</p></div>
                                                </div>
                                            </div>
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {this.state.modalType === "consent" && (
                            <div className='modal-consent-container'>
                                <div className='modal-consent-container-header'>
                                    <div className='modal-consent-container-header-left'>
                                        <h1>Before you subscribe</h1>
                                        <h3>Please confirm you're happy to receive emails from us</h3>
                                    </div>
                                    <div className='modal-consent-container-header-right'>
                                        <img onClick={this.closeModal} src='/assets/close-icon.png'/>
                                    </div>
                                </div>
                                <div className='modal-consent-container-body'>
                                    <p>By subscribing you agree to:</p>
                                    <ul>
                                        <li>Receive a <strong>weekly remote job newsletter</strong> from Jobo</li>
                                        <li>Occasional platform-related announcements</li>
                                    </ul>

                                    {/* ✅ NEW: Beehiiv compliance section */}
                                    <p style={{ marginTop: '15px' }}>
                                        Our newsletter is powered by Beehiiv. By subscribing, you also agree to Beehiiv's{' '}
                                        <span 
                                            onClick={() => window.open('https://www.beehiiv.com/tou', '_blank')}
                                            className='modal-consent-privacy-link'
                                        >
                                            Terms of Use
                                        </span>
                                        {' '}and{' '}
                                        <span 
                                            onClick={() => window.open('https://www.beehiiv.com/privacy', '_blank')}
                                            className='modal-consent-privacy-link'
                                        >
                                            Privacy Policy
                                        </span>.
                                    </p>

                                    <p>You can unsubscribe at any time via the link in any email we send. We will never sell or share your email address with third parties.</p>
                                    <p>
                                        For full details see our{' '}
                                        <span 
                                            onClick={() => window.open('https://www.notion.so/Privacy-Policy-2fb9fd4feb7480b6aeaffec54c44fb3d', '_blank')}
                                            className='modal-consent-privacy-link'
                                        >
                                            Privacy Policy
                                        </span>.
                                    </p>
                                </div>
                                <div className='modal-consent-container-footer'>
                                    <div 
                                        className='modal-consent-container-footer-btn decline'
                                        onClick={this.closeModal}
                                    >
                                        Cancel
                                    </div>
                                    <div 
                                        className='modal-consent-container-footer-btn confirm'
                                        onClick={this.confirmSubscribe}
                                    >
                                        I agree — Subscribe me
                                    </div>
                                </div>
                            </div>
                        )}
 
                        {this.state.modalType === "schedule-interview" && (
                            <div className='modal-schedule-interview-container'>
                            <div className='modal-schedule-interview-container-header'>
                                <div className='modal-schedule-interview-container-header-left'>
                                <h1>Schedule Interview</h1>
                                <h3>{selectedJob?.title} at {selectedJob?.company}</h3>
                                </div>
                                <div className='modal-schedule-interview-container-header-right'>
                                <img onClick={this.closeModal} src='/assets/close-icon.png' alt="Close"/>
                                </div>
                            </div>

                            <div className='modal-schedule-interview-container-body'>
                                <div className='modal-schedule-interview-form'>
                                
                                <div className='form-group'>
                                    <label>
                                    <span>Candidate Name:</span>
                                    </label>
                                    <input
                                    type="text"
                                    value={this.state.candidateName}
                                    onChange={(e) => this.setState({ candidateName: e.target.value })}
                                    placeholder="Enter candidate's full name"
                                    disabled={this.state.schedulingMeeting}
                                    />
                                </div>

                                <div className='form-group'>
                                    <label>
                                    <span>Candidate Email (optional):</span>
                                    </label>
                                    <input
                                    type="email"
                                    value={this.state.candidateEmail}
                                    onChange={(e) => this.setState({ candidateEmail: e.target.value })}
                                    placeholder="candidate@example.com"
                                    disabled={this.state.schedulingMeeting}
                                    />
                                </div>

                                <div className='form-group'>
                                    <label>
                                    <span>Interview Date:</span>
                                    </label>
                                    <input
                                    type="date"
                                    value={this.state.interviewDate}
                                    onChange={(e) => this.setState({ interviewDate: e.target.value })}
                                    min={new Date().toISOString().split('T')[0]}
                                    disabled={this.state.schedulingMeeting}
                                    />
                                </div>

                                <div className='form-group'>
                                    <label>
                                    <span>Interview Time:</span>
                                    </label>
                                    <input
                                    type="time"
                                    value={this.state.interviewTime}
                                    onChange={(e) => this.setState({ interviewTime: e.target.value })}
                                    disabled={this.state.schedulingMeeting}
                                    />
                                </div>

                                <div className='modal-schedule-interview-info'>
                                    <p>📹 A 40-minute Zoom meeting will be created</p>
                                    <p>🔒 Waiting room enabled for security</p>
                                    <p>⏰ Timezone: Africa/Nairobi (EAT)</p>
                                </div>

                                <div className='modal-schedule-interview-buttons'>
                                    <button
                                    className='btn-cancel'
                                    onClick={this.closeModal}
                                    disabled={this.state.schedulingMeeting}
                                    >
                                    Cancel
                                    </button>
                                    <button
                                    className='btn-schedule'
                                    onClick={this.createInterviewMeeting}
                                    disabled={this.state.schedulingMeeting}
                                    >
                                    {this.state.schedulingMeeting ? 'Scheduling...' : 'Schedule Meeting'}
                                    </button>
                                </div>

                                </div>
                            </div>
                            </div>
                        )}
                        

                    </Modal>

                    <div className="home-container-header">
                        <h4><span></span>support@joboremotejobs.com</h4>
                        <div className='home-container-header-subscription-box'>
                            <h5>Receive remote job opportunities via email weekly.</h5>
                            <div className='home-container-header-subscription-box-left'>
                                <div className={`home-container-header-subscription-box-left-email-box ${this.state.subscriberEmailInvalid ? 'isEmpty' : ''}`}>
                                    <input 
                                    type='email'
                                    id='subsriberEmail'
                                    placeholder='Enter your email here'
                                    value={this.state.subscriberEmail}
                                    onChange={this.handleSubscriberEmailChange}
                                    />
                                </div>
                            </div>
                            <div className='home-container-header-subscription-box-right'>
                                <div className='home-container-header-subscription-box-right-subscribe-btn-box'>
                                    <div 
                                    onClick={this.handleEmailSubscriberClicked}
                                    className={`home-container-header-subscription-box-right-subscribe-btn ${this.state.emailSubscribing ? 'clicked' : ''}`}>
                                        <p>{this.state.emailSubscribing ? 'Subscribing...' : 'Subscribe'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <img src='/assets/jobo-logo2.png'/>
                    </div>
                    <div className="home-container-body">

                        <div className="home-container-body-left-panel">
                            <div className='home-container-body-left-panel-header'>

                            </div>
                            <div className='home-container-body-left-panel-body'>
                                <div className='home-container-body-left-panel-body-top-section'>
                                    <div className='home-container-body-left-panel-body-section-cell'>
                                        <div className='home-container-body-left-panel-body-section-cell-icon'>
                                            <img src='/assets/search-icon2.png'/>
                                        </div>
                                        <div className='home-container-body-left-panel-body-section-cell-text'>
                                            <p>Search Jobs</p>
                                        </div>
                                    </div>
                                   {/* <div className={`home-container-body-left-panel-body-section-cell ${this.state.studySessionsPageVisible ? 'selected' : ''}`}>
                                        <div className='home-container-body-left-panel-body-section-cell-icon'>
                                            <img src='/assets/study-sessions-icon2.png'/>
                                        </div>
                                        <div onClick={this.handleToggleStudySessions} className='home-container-body-left-panel-body-section-cell-text'>
                                            <p>Study Sessions</p>
                                        </div>
                                    </div> */}
                                    {/* <div className='home-container-body-left-panel-body-section-cell'>
                                        <div className='home-container-body-left-panel-body-section-cell-icon'>
                                            <img src='/assets/track-apps-icon.png'/>
                                        </div>
                                        <div className='home-container-body-left-panel-body-section-cell-text'>
                                            <p>Track Applications</p>
                                        </div>
                                    </div>
                                    <div className='home-container-body-left-panel-body-section-cell'>
                                        <div className='home-container-body-left-panel-body-section-cell-icon'>
                                            <img src='/assets/games-icon.png'/>
                                        </div>
                                        <div className='home-container-body-left-panel-body-section-cell-text'>
                                            <p>Games</p>
                                        </div>
                                    </div> */}
                                </div>
                                {/* <div className='home-container-body-left-panel-body-bottom-section'>
                                    <div className='home-container-body-left-panel-body-section-cell'>
                                        <div className='home-container-body-left-panel-body-section-cell-icon'>
                                            <img src='/assets/job-post-icon.png'/>
                                        </div>
                                        <div className='home-container-body-left-panel-body-section-cell-text'>
                                            <p>Post a Job</p>
                                        </div>
                                    </div>
                                    <div className='home-container-body-left-panel-body-section-cell'>
                                        <div className='home-container-body-left-panel-body-section-cell-icon'>
                                            <img src='/assets/report-icon.png'/>
                                        </div>
                                        <div className='home-container-body-left-panel-body-section-cell-text'>
                                            <p>Report issue</p>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className='home-container-body-left-panel-footer'>
                                <p>© 2026 Jobo</p>
                            </div>
                        </div>
                        <div className={`home-container-body-center-panel-study-session ${this.state.studySessionsPageVisible ? 'visible' : ''}`}>
                            <h1>Study Sessions Page</h1>
                        </div>

                        <div className={centerPanelClass}>
                            <div className="home-container-body-center-panel-header">
                                <div className="home-container-body-center-panel-header-search">
                                    <div className="home-container-body-center-panel-header-search-box">
                                        <div className="home-container-body-center-panel-header-search-box-left">
                                            <img src='/assets/search-icon.png'/>
                                        </div>
                                        <div className="home-container-body-center-panel-header-search-box-center">
                                            <input 
                                            id="searchBarText"
                                            placeholder="Search by skills, role, or keywords..."
                                            type='text'
                                            value={searchQuery}
                                            onChange={this.handleSearchInput}
                                            onFocus={() => this.setState({ showSuggestions: true })}
                                            onBlur={() => setTimeout(() => this.setState({ showSuggestions: false }), 200)}
                                            // style={{
                                            //     width: '100%',
                                            //     padding: '12px',
                                            //     fontSize: '16px',
                                            //     border: '1px solid #ccc',
                                            //     borderRadius: '4px'
                                            // }}
                                            />
                                            {showSuggestions && suggestedKeywords.length > 0 && (
                                            <div 
                                                className="suggestions-dropdown"
                                                style={{
                                                position: 'absolute',
                                                top: '115%',
                                                left: 0,
                                                right: 0,
                                                backgroundColor: 'white',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                maxHeight: '300px',
                                                overflowY: 'auto',
                                                zIndex: 1000,
                                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                                }}
                                            >
                                                {suggestedKeywords.map((keywordObj, index) => (
                                                <div
                                                    key={index}
                                                    onClick={() => this.handleSelectKeyword(keywordObj)}
                                                    style={{
                                                    padding: '10px 12px',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #f0f0f0',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                                >
                                                    <span>{keywordObj.keyword}</span>
                                                    <span style={{ 
                                                    color: '#666', 
                                                    fontSize: '12px',
                                                    backgroundColor: '#e0e0e0',
                                                    padding: '2px 8px',
                                                    borderRadius: '12px'
                                                    }}>
                                                    {keywordObj.count} {keywordObj.count === 1 ? 'job' : 'jobs'}
                                                    </span>
                                                </div>
                                                ))}
                                            </div>
                                            )}
                                        </div>
                                        <div className="home-container-body-center-panel-header-search-box-right">

                                        </div>
                                    </div>
                                </div>
                                <div className="home-container-body-center-panel-header-btns">
                                    <div className="home-container-body-center-panel-header-btns-left">
                                        <h1>{isFiltered ? displayedJobs.length : totalJobCount}</h1>
                                        <p>positions</p>
                                    </div>
                                    <div className="home-container-body-center-panel-header-btns-right">
                                        <div className="home-container-body-center-panel-header-btns-right-col">
                                            <div className="home-container-body-center-panel-header-btns-right-col-btn">
                                                <p><span>(mostly)</span> EMEA Remote</p>
                                            </div>
                                        </div>
                                        <div className="home-container-body-center-panel-header-btns-right-col">
                                            {/* <div 
                                            onClick={this.categoryMenuClick}
                                            className="home-container-body-center-panel-header-btns-right-col-btn">
                                                <p>Job Categories</p>
                                            </div> */}
                                            <div className={`home-container-body-center-panel-header-btns-right-col-options ${this.state.categoryOptionsVisible ? 'visible' : ''}`}>
                                                
                                            </div>
                                        </div>
                                        {/* <div className="home-container-body-center-panel-header-btns-right-col">
                                            <div
                                            onClick={this.salaryRangeMenuClick}
                                            className="home-container-body-center-panel-header-btns-right-col-btn">
                                                <p>Salary Range</p>
                                            </div>
                                            <div className={`home-container-body-center-panel-header-btns-right-col-options ${this.state.salaryRangeOptionsVisible ? 'visible' : ''}`}>
                                                
                                            </div>
                                        </div> */}
                                        <div className="home-container-body-center-panel-header-btns-right-col">

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="home-container-body-center-panel-body" ref={this.scrollContainerRef}>
                                <div className='home-container-body-center-panel-body-job-posts'>
                                {/* Job Count */}
                                <div className="job-board-count" style={{borderBottom: newJobLoading ? '0.5px solid #ccc' : 'none' }}>
                                    {/* <p>{displayedJobs.length} jobs found</p> */}
                                    {newJobLoading && (
                                    <p style={{ color: '#4CAF50', fontWeight: 'bold', marginLeft: '10px' }}>
                                        ✨ New job being processed...
                                    </p>
                                    )}
                                </div>
                                {displayedJobs.map((job) => (
                                    <div 
                                        key={job.id}
                                        className={`home-container-body-center-panel-body-job-post ${selectedJobId === job.id && 'selected'}`}
                                        onClick={() => this.handleJobClick(job.id)}
                                        >
                                        <div className={`home-container-body-center-panel-body-job-post-selected ${selectedJobId === job.id && 'true'}`}>
                                            {/* {selectedJobId === job.id && <span>✓</span>} */}
                                        </div>
                                        <div className="home-container-body-center-panel-body-job-post-icon">
                                            <img 
                                                src={`/assets/${job.company?.charAt(0).toUpperCase()}-letter.png`} 
                                                alt={job.company}
                                            />
                                            <h5>{job.company}</h5>
                                        </div>
                                        <div className="home-container-body-center-panel-body-job-post-details">
                                            <div className="home-container-body-center-panel-body-job-post-details-top">
                                                <h2>{job.title}</h2>
                                                <h3>{job.salary}</h3>
                                            </div>
                                            <div className="home-container-body-center-panel-body-job-post-details-middle">
                                            <div className="home-container-body-center-panel-body-job-post-details-middle-left">
                                                <p>Requirements:</p>
                                                {job.requirements && job.requirements.length > 0 && (
                                                    <ul>
                                                        {job.requirements.slice(0, 3).map((req, index) => (
                                                            <li key={index}>{req}</li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                            <div className="home-container-body-center-panel-body-job-post-details-middle-right">
                                                <p>About the role:</p>
                                                <h4>{job.description}</h4>
                                            </div>
                                            </div>
                                            <div className="home-container-body-center-panel-body-job-post-details-bottom">
                                                <h5>{this.formatPostedDate(job.postedDate)}</h5>
                                                <h3>{job.salary}</h3>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                
                                {/* Sentinel element for infinite scroll */}
                                <div 
                                className='home-container-body-center-panel-body-job-posts-loading-sentinel'
                                ref={this.sentinelRef} 
                                style={{ visibility: 'hidden', paddingBottom: '70px', width: '100%' }}
                                />

                                {/* Loading indicator */}
                                {loading && (
                                    <div style={{marginTop: '-7.5vh',}} className="job-board-loading">
                                        <p >Loading jobs...</p>
                                    </div>
                                )}

                                {/* End of results message */}
                                {!this.state.hasMore && !loading && displayedJobs.length > 0 && (
                                    <div style={{marginTop: '0px'}} className="job-board-end">
                                        
                                    </div>
                                )}

                                {/* No results message */}
                                {displayedJobs.length === 0 && !loading && (
                                    <div className="job-board-empty">
                                        <p>No jobs match your search criteria</p>
                                    </div>
                                )}
                                </div>
                            </div>
                        </div>

                        {/* 🚨 NEW: THE OVERLAY BACKDROP */}
                        <div 
                            className={backdropClass}
                            // Attaching the close function to the backdrop click
                            onClick={this.handleCloseRightPanel}
                        ></div>

                        {/* 3. RIGHT PANEL (Details - Slide-in Overlay) */}
                        <div className={rightPanelClass}>
                            <div className='home-container-body-right-panel-body-top-header-right'>
                                {/* Add a close button that uses the new handler */}
                                <img 
                                    className='home-container-body-right-panel-body-top-header-right-close-btn'
                                    src='/assets/close-icon.png' // Replace with your actual close icon asset
                                    alt="Close" 
                                    onClick={this.handleCloseRightPanel} 
                                />
                            </div>
                            {!selectedJob ? (
                                <div className="home-container-body-right-panel-placeholder">
                                    <div className="home-container-body-right-panel-placeholder-icon">
                                        <img src='/assets/search-icon.png' alt="Select a job" />
                                    </div>
                                    <h2>Select a job to view details</h2>
                                    <p>Click on any job posting from the list to see the full description, requirements, and application link.</p>
                                </div>
                            ) : (
                                <div className="home-container-body-right-panel-body">
                                    <div className="home-container-body-right-panel-body-top">
                                        <div className="home-container-body-right-panel-body-top-header">
                                            <div className="home-container-body-right-panel-body-top-header-left">
                                                {/* <img 
                                                    src={`/assets/${selectedJob?.company?.charAt(0).toUpperCase()}-letter.png`} 
                                                    alt={selectedJob?.company}
                                                /> */}
                                                <div className="home-container-body-right-panel-body-top-header-left-text">
                                                    <h3>{selectedJob?.company}</h3>
                                                    <p onClick={this.visitWebsiteBtnClicked}>Visit website <span><img src='/assets/external-share-icon.png'/></span></p>
                                                </div>
                                            </div>
                                            <div className="home-container-body-right-panel-body-top-header-right">
                                                <img onClick={this.selectedJobOptionsClicked} src='/assets/three-dots-icon.png'/>
                                            </div>
                                        </div>
                                        <div className={`home-container-body-right-panel-body-top-body-popup ${this.state.selectedJobOptionsVisible ? 'visible' : ''}`}>
                                            <div onClick={() => this.toggleModal("share")} className='home-container-body-right-panel-body-top-body-popup-cell'>
                                                <div  className='home-container-body-right-panel-body-top-body-popup-cell-icon'>
                                                    <img src='/assets/share-icon2.png'/>
                                                </div>
                                                <div className='home-container-body-right-panel-body-top-body-popup-cell-text'>
                                                    <p>Share</p>
                                                </div>
                                            </div>
                                            <div  onClick={() => this.toggleModal("report")}  className='home-container-body-right-panel-body-top-body-popup-cell'>
                                                <div className='home-container-body-right-panel-body-top-body-popup-cell-icon'>
                                                    <img src='/assets/report-job-icon2.png'/>
                                                </div>
                                                <div className='home-container-body-right-panel-body-top-body-popup-cell-text'>
                                                    <p>Report job</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="home-container-body-right-panel-body-top-body">
                                            <h2>{selectedJob?.title}</h2>
                                            <div className="home-container-body-right-panel-body-top-body-job-details">
                                                <p>{selectedJob?.postedDate && this.formatPostedDate(selectedJob.postedDate)}</p>
                                                <h4>{selectedJob?.salary}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="home-container-body-right-panel-body-bottom" ref={this.jobDetailsRef}>
                                        <h3>Description:</h3>
                                        {selectedJob?.fullJobPost ? (
                                            <div dangerouslySetInnerHTML={{ __html: this.formatJobPost(selectedJob.fullJobPost) }} />
                                        ) : (
                                            <p>No job description available.</p>
                                        )}
                                    </div>
                                </div>
                            )}
                            <div className="home-container-body-right-panel-footer">
                                <button
                                    onClick={() => this.applyBtnClicked(selectedJob?.jobAppURL)}
                                    disabled={!selectedJob}
                                    className={!selectedJob ? 'disabled' : ''}
                                >
                                    Apply
                                </button>
                            </div>  
                        </div>
                        {/* <div className={rightPanelClass}>
                            
                        </div> */}
                    </div>
                </div>
            </Styles>
        )
    }
}